//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class ApplicationLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    logEvent(command: LogApplicationEventCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ApplicationLog/LogEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLogEvent(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApplicationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getReceipt(personDocumentId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Applications/GetReceipt/{personDocumentId}";
        if (personDocumentId === undefined || personDocumentId === null)
            throw new globalThis.Error("The parameter 'personDocumentId' must be defined.");
        url_ = url_.replace("{personDocumentId}", encodeURIComponent("" + personDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetReceipt(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    exchangeIdpToken(tokenExchangeCommand: ExchangeIdpTokenCommand): Observable<TokenExchangeDto> {
        let url_ = this.baseUrl + "/api/Auth/ExchangeIdpToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tokenExchangeCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExchangeIdpToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExchangeIdpToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenExchangeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenExchangeDto>;
        }));
    }

    protected processExchangeIdpToken(response: HttpResponseBase): Observable<TokenExchangeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenExchangeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createNonProdUserToken(nonProdUserCommand: CreateNonProdUserTokenCommand): Observable<TokenExchangeDto> {
        let url_ = this.baseUrl + "/api/Auth/CreateNonProdUserToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nonProdUserCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNonProdUserToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNonProdUserToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenExchangeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenExchangeDto>;
        }));
    }

    protected processCreateNonProdUserToken(response: HttpResponseBase): Observable<TokenExchangeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenExchangeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshToken(): Observable<TokenRefreshResult> {
        let url_ = this.baseUrl + "/api/Auth/RefreshToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenRefreshResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenRefreshResult>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<TokenRefreshResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenRefreshResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logout(command: UserLogoutCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Auth/Logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorsToImpersonate(query: GetEducatorEINsQuery): Observable<EducatorEINDto[]> {
        let url_ = this.baseUrl + "/api/Auth/GetEducatorsToImpersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorsToImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorsToImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorEINDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorEINDto[]>;
        }));
    }

    protected processGetEducatorsToImpersonate(response: HttpResponseBase): Observable<EducatorEINDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorEINDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorInfo(): Observable<EducatorInfoDto> {
        let url_ = this.baseUrl + "/api/Auth/GetEducatorInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorInfoDto>;
        }));
    }

    protected processGetEducatorInfo(response: HttpResponseBase): Observable<EducatorInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorInfoDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeStepOneVerification(command: EducatorVerificationStepOneCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Auth/CompleteStepOneVerification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteStepOneVerification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteStepOneVerification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCompleteStepOneVerification(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorVerificationInformation(): Observable<EducatorVerificationInformationDto> {
        let url_ = this.baseUrl + "/api/Auth/GetEducatorVerificationInformation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorVerificationInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorVerificationInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorVerificationInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorVerificationInformationDto>;
        }));
    }

    protected processGetEducatorVerificationInformation(response: HttpResponseBase): Observable<EducatorVerificationInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorVerificationInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeStepTwoVerificationDps(command: EducatorVerificationStepTwoDpsCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Auth/CompleteStepTwoVerificationDps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteStepTwoVerificationDps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteStepTwoVerificationDps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCompleteStepTwoVerificationDps(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeStepTwoVerificationContact(command: EducatorVerificationStepTwoContactCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Auth/CompleteStepTwoVerificationContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteStepTwoVerificationContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteStepTwoVerificationContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCompleteStepTwoVerificationContact(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeEducatorVerification(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Auth/CompleteEducatorVerification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteEducatorVerification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteEducatorVerification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCompleteEducatorVerification(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    keepAlive(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Auth/KeepAlive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKeepAlive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKeepAlive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processKeepAlive(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getADEConnectRegistrationLink(): Observable<string> {
        let url_ = this.baseUrl + "/api/Auth/GetADEConnectRegistrationLink";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetADEConnectRegistrationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetADEConnectRegistrationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetADEConnectRegistrationLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BackgroundCheckQuestionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getBackgroundCheckQuestions(): Observable<PendingApplicationBackgroundCheckResponseDto[]> {
        let url_ = this.baseUrl + "/api/BackgroundCheckQuestions/GetBackgroundCheckQuestions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBackgroundCheckQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBackgroundCheckQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingApplicationBackgroundCheckResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingApplicationBackgroundCheckResponseDto[]>;
        }));
    }

    protected processGetBackgroundCheckQuestions(response: HttpResponseBase): Observable<PendingApplicationBackgroundCheckResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingApplicationBackgroundCheckResponseDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    doesBackgroundIssuesAlertExist(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/BackgroundCheckQuestions/DoesBackgroundIssuesAlertExist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDoesBackgroundIssuesAlertExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDoesBackgroundIssuesAlertExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDoesBackgroundIssuesAlertExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateBackgroundCheckQuestionResponses(command: AddOrUpdateBackgroundCheckQuestionResponsesCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BackgroundCheckQuestions/AddOrUpdateBackgroundCheckQuestionResponses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateBackgroundCheckQuestionResponses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateBackgroundCheckQuestionResponses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddOrUpdateBackgroundCheckQuestionResponses(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CertificatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEducatorCertificates(): Observable<EducatorCertificateDto[]> {
        let url_ = this.baseUrl + "/api/Certificates/GetEducatorCertificates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorCertificates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorCertificates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorCertificateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorCertificateDto[]>;
        }));
    }

    protected processGetEducatorCertificates(response: HttpResponseBase): Observable<EducatorCertificateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorCertificateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateVerificationLetter(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Certificates/GetCertificateVerificationLetter";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateVerificationLetter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateVerificationLetter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetCertificateVerificationLetter(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CodeTablesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getStates(): Observable<StateDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StateDto[]>;
        }));
    }

    protected processGetStates(response: HttpResponseBase): Observable<StateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStatesNoAZ(): Observable<StateDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetStatesNoAZ";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatesNoAZ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatesNoAZ(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StateDto[]>;
        }));
    }

    protected processGetStatesNoAZ(response: HttpResponseBase): Observable<StateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonPhoneCodes(): Observable<PhoneCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetPersonPhoneCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonPhoneCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonPhoneCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhoneCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhoneCodeDto[]>;
        }));
    }

    protected processGetPersonPhoneCodes(response: HttpResponseBase): Observable<PhoneCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PhoneCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonEmailCodes(personId?: number | undefined): Observable<EmailCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetPersonEmailCodes?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonEmailCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonEmailCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailCodeDto[]>;
        }));
    }

    protected processGetPersonEmailCodes(response: HttpResponseBase): Observable<EmailCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContactTypeCodes(): Observable<ContactTypeCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetContactTypeCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactTypeCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactTypeCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactTypeCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactTypeCodeDto[]>;
        }));
    }

    protected processGetContactTypeCodes(response: HttpResponseBase): Observable<ContactTypeCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactTypeCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLocationCodes(): Observable<LocationCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetLocationCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationCodeDto[]>;
        }));
    }

    protected processGetLocationCodes(response: HttpResponseBase): Observable<LocationCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocationCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApprovedAreaCodes(): Observable<ApprovedAreaCodeDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetApprovedAreaCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovedAreaCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovedAreaCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovedAreaCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovedAreaCodeDto[]>;
        }));
    }

    protected processGetApprovedAreaCodes(response: HttpResponseBase): Observable<ApprovedAreaCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApprovedAreaCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLeaCodes(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetLeaCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeaCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetLeaCodes(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPreparationInstitutions(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetPreparationInstitutions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreparationInstitutions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreparationInstitutions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetPreparationInstitutions(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDegreeCodes(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetDegreeCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDegreeCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDegreeCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetDegreeCodes(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAccreditedInstitutionsByState(stateCodeId?: number | undefined): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetAccreditedInstitutionsByState?";
        if (stateCodeId === null)
            throw new globalThis.Error("The parameter 'stateCodeId' cannot be null.");
        else if (stateCodeId !== undefined)
            url_ += "stateCodeId=" + encodeURIComponent("" + stateCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccreditedInstitutionsByState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccreditedInstitutionsByState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetAccreditedInstitutionsByState(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDegreeTypesByDegree(degreeCodeId?: number | undefined): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetDegreeTypesByDegree?";
        if (degreeCodeId === null)
            throw new globalThis.Error("The parameter 'degreeCodeId' cannot be null.");
        else if (degreeCodeId !== undefined)
            url_ += "degreeCodeId=" + encodeURIComponent("" + degreeCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDegreeTypesByDegree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDegreeTypesByDegree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetDegreeTypesByDegree(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLanguageCodes(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/CodeTables/GetLanguageCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetLanguageCodes(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CompleteApplicationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getApplicationSummary(): Observable<ApplicationSummaryDto> {
        let url_ = this.baseUrl + "/api/CompleteApplication/GetApplicationSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationSummaryDto>;
        }));
    }

    protected processGetApplicationSummary(response: HttpResponseBase): Observable<ApplicationSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPaymentSummary(): Observable<PaymentSummaryDto> {
        let url_ = this.baseUrl + "/api/CompleteApplication/GetPaymentSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentSummaryDto>;
        }));
    }

    protected processGetPaymentSummary(response: HttpResponseBase): Observable<PaymentSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPayment(command: CreatePaymentRequestCommand): Observable<SnapPayPaymentRequestModel> {
        let url_ = this.baseUrl + "/api/CompleteApplication/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SnapPayPaymentRequestModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SnapPayPaymentRequestModel>;
        }));
    }

    protected processCreatePayment(response: HttpResponseBase): Observable<SnapPayPaymentRequestModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapPayPaymentRequestModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPaymentStatus(): Observable<PendingPaymentStatus> {
        let url_ = this.baseUrl + "/api/CompleteApplication/GetPaymentStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingPaymentStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingPaymentStatus>;
        }));
    }

    protected processGetPaymentStatus(response: HttpResponseBase): Observable<PendingPaymentStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingPaymentStatus;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeIncompletePayment(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/CompleteApplication/RemoveIncompletePayment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveIncompletePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveIncompletePayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveIncompletePayment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completePayment(accountId?: string | null | undefined, customerId?: string | null | undefined, companyCode?: string | null | undefined, currencyCode?: string | null | undefined, merchantId?: string | null | undefined, paymentTransactionId?: string | null | undefined, pgTransactionId?: string | null | undefined, transactionAmount?: string | null | undefined, authorizationNumber?: string | null | undefined, returnMessage?: string | null | undefined, transactionStatus?: string | null | undefined, pgReturnCode?: string | null | undefined, pgReturnDescription?: string | null | undefined, transactionDate?: string | null | undefined, respproc?: string | null | undefined, userFields?: string | null | undefined, pgText?: string | null | undefined, paymentMethodType?: string | null | undefined, paymentMethodLast4?: string | null | undefined, paymentMethodToken?: string | null | undefined, paymentMethodFirstName?: string | null | undefined, paymentMethodLastName?: string | null | undefined, paymentMethodExpirationMonth?: string | null | undefined, paymentMethodExpirationYear?: string | null | undefined, paymentMethodRoutingNumber?: string | null | undefined, paymentMethodAddressLine1?: string | null | undefined, paymentMethodCity?: string | null | undefined, paymentMethodState?: string | null | undefined, paymentMethodZip?: string | null | undefined, paymentMethodCountry?: string | null | undefined, paymentMethodEmail?: string | null | undefined, paymentMethodPhoneNumber?: string | null | undefined, feePgTransactionId?: string | null | undefined, feeAmount?: string | null | undefined, feeAuthorizationNumber?: string | null | undefined, feeTransactionStatus?: string | null | undefined, feePgReturnCode?: string | null | undefined, feePgReturnDescription?: string | null | undefined, feeTransactionDate?: string | null | undefined, feeRespproc?: string | null | undefined, feePgText?: string | null | undefined, feePaymentTransactionId?: string | null | undefined, feeFormat?: string | null | undefined, feeType?: string | null | undefined, feeValue?: string | null | undefined, signature?: string | null | undefined, udf0?: string | null | undefined, udf1?: string | null | undefined, udf2?: string | null | undefined, udf3?: string | null | undefined, udf4?: string | null | undefined, udf5?: string | null | undefined, udf6?: string | null | undefined, udf7?: string | null | undefined, udf8?: string | null | undefined, udf9?: string | null | undefined): Observable<SnapPayPaymentResponseModel> {
        let url_ = this.baseUrl + "/api/CompleteApplication/CompletePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (accountId !== null && accountId !== undefined)
            content_.append("AccountId", accountId.toString());
        if (customerId !== null && customerId !== undefined)
            content_.append("CustomerId", customerId.toString());
        if (companyCode !== null && companyCode !== undefined)
            content_.append("CompanyCode", companyCode.toString());
        if (currencyCode !== null && currencyCode !== undefined)
            content_.append("CurrencyCode", currencyCode.toString());
        if (merchantId !== null && merchantId !== undefined)
            content_.append("MerchantId", merchantId.toString());
        if (paymentTransactionId !== null && paymentTransactionId !== undefined)
            content_.append("PaymentTransactionId", paymentTransactionId.toString());
        if (pgTransactionId !== null && pgTransactionId !== undefined)
            content_.append("PgTransactionId", pgTransactionId.toString());
        if (transactionAmount !== null && transactionAmount !== undefined)
            content_.append("TransactionAmount", transactionAmount.toString());
        if (authorizationNumber !== null && authorizationNumber !== undefined)
            content_.append("AuthorizationNumber", authorizationNumber.toString());
        if (returnMessage !== null && returnMessage !== undefined)
            content_.append("ReturnMessage", returnMessage.toString());
        if (transactionStatus !== null && transactionStatus !== undefined)
            content_.append("TransactionStatus", transactionStatus.toString());
        if (pgReturnCode !== null && pgReturnCode !== undefined)
            content_.append("PgReturnCode", pgReturnCode.toString());
        if (pgReturnDescription !== null && pgReturnDescription !== undefined)
            content_.append("PgReturnDescription", pgReturnDescription.toString());
        if (transactionDate !== null && transactionDate !== undefined)
            content_.append("TransactionDate", transactionDate.toString());
        if (respproc !== null && respproc !== undefined)
            content_.append("Respproc", respproc.toString());
        if (userFields !== null && userFields !== undefined)
            content_.append("UserFields", userFields.toString());
        if (pgText !== null && pgText !== undefined)
            content_.append("PgText", pgText.toString());
        if (paymentMethodType !== null && paymentMethodType !== undefined)
            content_.append("PaymentMethodType", paymentMethodType.toString());
        if (paymentMethodLast4 !== null && paymentMethodLast4 !== undefined)
            content_.append("PaymentMethodLast4", paymentMethodLast4.toString());
        if (paymentMethodToken !== null && paymentMethodToken !== undefined)
            content_.append("PaymentMethodToken", paymentMethodToken.toString());
        if (paymentMethodFirstName !== null && paymentMethodFirstName !== undefined)
            content_.append("PaymentMethodFirstName", paymentMethodFirstName.toString());
        if (paymentMethodLastName !== null && paymentMethodLastName !== undefined)
            content_.append("PaymentMethodLastName", paymentMethodLastName.toString());
        if (paymentMethodExpirationMonth !== null && paymentMethodExpirationMonth !== undefined)
            content_.append("PaymentMethodExpirationMonth", paymentMethodExpirationMonth.toString());
        if (paymentMethodExpirationYear !== null && paymentMethodExpirationYear !== undefined)
            content_.append("PaymentMethodExpirationYear", paymentMethodExpirationYear.toString());
        if (paymentMethodRoutingNumber !== null && paymentMethodRoutingNumber !== undefined)
            content_.append("PaymentMethodRoutingNumber", paymentMethodRoutingNumber.toString());
        if (paymentMethodAddressLine1 !== null && paymentMethodAddressLine1 !== undefined)
            content_.append("PaymentMethodAddressLine1", paymentMethodAddressLine1.toString());
        if (paymentMethodCity !== null && paymentMethodCity !== undefined)
            content_.append("PaymentMethodCity", paymentMethodCity.toString());
        if (paymentMethodState !== null && paymentMethodState !== undefined)
            content_.append("PaymentMethodState", paymentMethodState.toString());
        if (paymentMethodZip !== null && paymentMethodZip !== undefined)
            content_.append("PaymentMethodZip", paymentMethodZip.toString());
        if (paymentMethodCountry !== null && paymentMethodCountry !== undefined)
            content_.append("PaymentMethodCountry", paymentMethodCountry.toString());
        if (paymentMethodEmail !== null && paymentMethodEmail !== undefined)
            content_.append("PaymentMethodEmail", paymentMethodEmail.toString());
        if (paymentMethodPhoneNumber !== null && paymentMethodPhoneNumber !== undefined)
            content_.append("PaymentMethodPhoneNumber", paymentMethodPhoneNumber.toString());
        if (feePgTransactionId !== null && feePgTransactionId !== undefined)
            content_.append("FeePgTransactionId", feePgTransactionId.toString());
        if (feeAmount !== null && feeAmount !== undefined)
            content_.append("FeeAmount", feeAmount.toString());
        if (feeAuthorizationNumber !== null && feeAuthorizationNumber !== undefined)
            content_.append("FeeAuthorizationNumber", feeAuthorizationNumber.toString());
        if (feeTransactionStatus !== null && feeTransactionStatus !== undefined)
            content_.append("FeeTransactionStatus", feeTransactionStatus.toString());
        if (feePgReturnCode !== null && feePgReturnCode !== undefined)
            content_.append("FeePgReturnCode", feePgReturnCode.toString());
        if (feePgReturnDescription !== null && feePgReturnDescription !== undefined)
            content_.append("FeePgReturnDescription", feePgReturnDescription.toString());
        if (feeTransactionDate !== null && feeTransactionDate !== undefined)
            content_.append("FeeTransactionDate", feeTransactionDate.toString());
        if (feeRespproc !== null && feeRespproc !== undefined)
            content_.append("FeeRespproc", feeRespproc.toString());
        if (feePgText !== null && feePgText !== undefined)
            content_.append("FeePgText", feePgText.toString());
        if (feePaymentTransactionId !== null && feePaymentTransactionId !== undefined)
            content_.append("FeePaymentTransactionId", feePaymentTransactionId.toString());
        if (feeFormat !== null && feeFormat !== undefined)
            content_.append("FeeFormat", feeFormat.toString());
        if (feeType !== null && feeType !== undefined)
            content_.append("FeeType", feeType.toString());
        if (feeValue !== null && feeValue !== undefined)
            content_.append("FeeValue", feeValue.toString());
        if (signature !== null && signature !== undefined)
            content_.append("Signature", signature.toString());
        if (udf0 !== null && udf0 !== undefined)
            content_.append("Udf0", udf0.toString());
        if (udf1 !== null && udf1 !== undefined)
            content_.append("Udf1", udf1.toString());
        if (udf2 !== null && udf2 !== undefined)
            content_.append("Udf2", udf2.toString());
        if (udf3 !== null && udf3 !== undefined)
            content_.append("Udf3", udf3.toString());
        if (udf4 !== null && udf4 !== undefined)
            content_.append("Udf4", udf4.toString());
        if (udf5 !== null && udf5 !== undefined)
            content_.append("Udf5", udf5.toString());
        if (udf6 !== null && udf6 !== undefined)
            content_.append("Udf6", udf6.toString());
        if (udf7 !== null && udf7 !== undefined)
            content_.append("Udf7", udf7.toString());
        if (udf8 !== null && udf8 !== undefined)
            content_.append("Udf8", udf8.toString());
        if (udf9 !== null && udf9 !== undefined)
            content_.append("Udf9", udf9.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SnapPayPaymentResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SnapPayPaymentResponseModel>;
        }));
    }

    protected processCompletePayment(response: HttpResponseBase): Observable<SnapPayPaymentResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnapPayPaymentResponseModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    submitFreeApplication(command: SubmitFreeApplicationCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/CompleteApplication/SubmitFreeApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitFreeApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitFreeApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSubmitFreeApplication(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAttestationConfirmation(attestationConfirmed?: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/CompleteApplication/UpdateAttestationConfirmation?";
        if (attestationConfirmed === null)
            throw new globalThis.Error("The parameter 'attestationConfirmed' cannot be null.");
        else if (attestationConfirmed !== undefined)
            url_ += "attestationConfirmed=" + encodeURIComponent("" + attestationConfirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAttestationConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAttestationConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateAttestationConfirmation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationCompleteState(): Observable<ApplicationCompleteStateDto> {
        let url_ = this.baseUrl + "/api/CompleteApplication/GetApplicationCompleteState";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationCompleteState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationCompleteState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationCompleteStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationCompleteStateDto>;
        }));
    }

    protected processGetApplicationCompleteState(response: HttpResponseBase): Observable<ApplicationCompleteStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationCompleteStateDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConfigClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    clientConfig(): Observable<EdPortalClientConfig> {
        let url_ = this.baseUrl + "/api/Config/ClientConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClientConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClientConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EdPortalClientConfig>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EdPortalClientConfig>;
        }));
    }

    protected processClientConfig(response: HttpResponseBase): Observable<EdPortalClientConfig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EdPortalClientConfig;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    featureConfig(): Observable<FeatureManagement> {
        let url_ = this.baseUrl + "/api/Config/FeatureConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFeatureConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFeatureConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureManagement>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureManagement>;
        }));
    }

    protected processFeatureConfig(response: HttpResponseBase): Observable<FeatureManagement> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeatureManagement;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reportError(command: ReportErrorCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Config/ReportError";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportError(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportError(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReportError(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CredentialsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getOwnedApprovedAreaCodes(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/Credentials/GetOwnedApprovedAreaCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOwnedApprovedAreaCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOwnedApprovedAreaCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetOwnedApprovedAreaCodes(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingApprovedAreaCodes(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/Credentials/GetPendingApprovedAreaCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingApprovedAreaCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingApprovedAreaCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetPendingApprovedAreaCodes(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistingDeficiencies(): Observable<ExistingDeficiencyDto[]> {
        let url_ = this.baseUrl + "/api/Credentials/GetExistingDeficiencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingDeficiencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingDeficiencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExistingDeficiencyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExistingDeficiencyDto[]>;
        }));
    }

    protected processGetExistingDeficiencies(response: HttpResponseBase): Observable<ExistingDeficiencyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistingDeficiencyDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificateRenewalContexts(): Observable<CertificateRenewalContextDto[]> {
        let url_ = this.baseUrl + "/api/Credentials/GetCertificateRenewalContexts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateRenewalContexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateRenewalContexts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificateRenewalContextDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificateRenewalContextDto[]>;
        }));
    }

    protected processGetCertificateRenewalContexts(response: HttpResponseBase): Observable<CertificateRenewalContextDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificateRenewalContextDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentName(): Observable<CurrentNameDto> {
        let url_ = this.baseUrl + "/api/Credentials/GetCurrentName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentNameDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentNameDto>;
        }));
    }

    protected processGetCurrentName(response: HttpResponseBase): Observable<CurrentNameDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CurrentNameDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCertificatesForCopyOfCert(): Observable<CertificateForCopyOfCertDto[]> {
        let url_ = this.baseUrl + "/api/Credentials/GetCertificatesForCopyOfCert";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificatesForCopyOfCert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificatesForCopyOfCert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificateForCopyOfCertDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificateForCopyOfCertDto[]>;
        }));
    }

    protected processGetCertificatesForCopyOfCert(response: HttpResponseBase): Observable<CertificateForCopyOfCertDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificateForCopyOfCertDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getValidInstitutionalRecommendations(): Observable<ValidInstitutionalRecommendationDto[]> {
        let url_ = this.baseUrl + "/api/Credentials/GetValidInstitutionalRecommendations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidInstitutionalRecommendations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidInstitutionalRecommendations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidInstitutionalRecommendationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidInstitutionalRecommendationDto[]>;
        }));
    }

    protected processGetValidInstitutionalRecommendations(response: HttpResponseBase): Observable<ValidInstitutionalRecommendationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidInstitutionalRecommendationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOwnedEndorsements(): Observable<OwnedEndorsementDto[]> {
        let url_ = this.baseUrl + "/api/Credentials/GetOwnedEndorsements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOwnedEndorsements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOwnedEndorsements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OwnedEndorsementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OwnedEndorsementDto[]>;
        }));
    }

    protected processGetOwnedEndorsements(response: HttpResponseBase): Observable<OwnedEndorsementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OwnedEndorsementDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExtendableCertificates(): Observable<ExtendableCertificateDto[]> {
        let url_ = this.baseUrl + "/api/Credentials/GetExtendableCertificates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExtendableCertificates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExtendableCertificates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtendableCertificateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtendableCertificateDto[]>;
        }));
    }

    protected processGetExtendableCertificates(response: HttpResponseBase): Observable<ExtendableCertificateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtendableCertificateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CspReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    report(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/csp-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DocumentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    uploadDocument(command: UploadDocumentCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Documents/UploadDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUploadDocument(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPrefilledW9File(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Documents/GetPrefilledW9File";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrefilledW9File(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrefilledW9File(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetPrefilledW9File(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentResults(): Observable<EducatorDocumentResultDto[]> {
        let url_ = this.baseUrl + "/api/Documents/GetDocumentResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorDocumentResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorDocumentResultDto[]>;
        }));
    }

    protected processGetDocumentResults(response: HttpResponseBase): Observable<EducatorDocumentResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorDocumentResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentById(personDocumentId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Documents/GetDocumentById/{personDocumentId}";
        if (personDocumentId === undefined || personDocumentId === null)
            throw new globalThis.Error("The parameter 'personDocumentId' must be defined.");
        url_ = url_.replace("{personDocumentId}", encodeURIComponent("" + personDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetDocumentById(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EducatorApplicationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEducatorApplications(): Observable<EducatorApplicationDto[]> {
        let url_ = this.baseUrl + "/api/EducatorApplications/GetEducatorApplications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorApplicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorApplicationDto[]>;
        }));
    }

    protected processGetEducatorApplications(response: HttpResponseBase): Observable<EducatorApplicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorApplicationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getServiceItemEvaluation(applicationServiceItemId?: number | undefined): Observable<EdPortalServiceItemEvaluationDto> {
        let url_ = this.baseUrl + "/api/EducatorApplications/GetServiceItemEvaluation?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "applicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceItemEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceItemEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EdPortalServiceItemEvaluationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EdPortalServiceItemEvaluationDto>;
        }));
    }

    protected processGetServiceItemEvaluation(response: HttpResponseBase): Observable<EdPortalServiceItemEvaluationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EdPortalServiceItemEvaluationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addEducatorAdditionalDocument(command: AddEducatorAdditionalDocumentCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/EducatorApplications/AddEducatorAdditionalDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEducatorAdditionalDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEducatorAdditionalDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddEducatorAdditionalDocument(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    canStartApplication(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/EducatorApplications/CanStartApplication";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanStartApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanStartApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processCanStartApplication(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationServiceItemEvaluationTimeline(applicationServiceItemId?: number | undefined): Observable<ServiceItemEvaluationTimelineItemDto[]> {
        let url_ = this.baseUrl + "/api/EducatorApplications/GetApplicationServiceItemEvaluationTimeline?";
        if (applicationServiceItemId === null)
            throw new globalThis.Error("The parameter 'applicationServiceItemId' cannot be null.");
        else if (applicationServiceItemId !== undefined)
            url_ += "applicationServiceItemId=" + encodeURIComponent("" + applicationServiceItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationServiceItemEvaluationTimeline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationServiceItemEvaluationTimeline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceItemEvaluationTimelineItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceItemEvaluationTimelineItemDto[]>;
        }));
    }

    protected processGetApplicationServiceItemEvaluationTimeline(response: HttpResponseBase): Observable<ServiceItemEvaluationTimelineItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceItemEvaluationTimelineItemDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEvaluationCommunicationImageContent(evaluationCommunicationImageId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/EducatorApplications/GetEvaluationCommunicationImageContent/{evaluationCommunicationImageId}";
        if (evaluationCommunicationImageId === undefined || evaluationCommunicationImageId === null)
            throw new globalThis.Error("The parameter 'evaluationCommunicationImageId' must be defined.");
        url_ = url_.replace("{evaluationCommunicationImageId}", encodeURIComponent("" + evaluationCommunicationImageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationCommunicationImageContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationCommunicationImageContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetEvaluationCommunicationImageContent(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FilesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getVerificationOfPreKTeachingExperienceForm(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Files/GetVerificationOfPreKTeachingExperienceForm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVerificationOfPreKTeachingExperienceForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVerificationOfPreKTeachingExperienceForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetVerificationOfPreKTeachingExperienceForm(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVerificationOfCteExperienceForm(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Files/GetVerificationOfCteExperienceForm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVerificationOfCteExperienceForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVerificationOfCteExperienceForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetVerificationOfCteExperienceForm(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVerificationOfProfessionalExperienceForm(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Files/GetVerificationOfProfessionalExperienceForm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVerificationOfProfessionalExperienceForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVerificationOfProfessionalExperienceForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetVerificationOfProfessionalExperienceForm(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HomeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEducatorToDoTasks(): Observable<EducatorToDoTaskDto[]> {
        let url_ = this.baseUrl + "/api/Home/GetEducatorToDoTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorToDoTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorToDoTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorToDoTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorToDoTaskDto[]>;
        }));
    }

    protected processGetEducatorToDoTasks(response: HttpResponseBase): Observable<EducatorToDoTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorToDoTaskDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorRequiresTour(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Home/GetEducatorRequiresTour";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorRequiresTour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorRequiresTour(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetEducatorRequiresTour(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NotificationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEducatorHomeNotifications(): Observable<EducatorNotificationHomeDto[]> {
        let url_ = this.baseUrl + "/api/Notifications/GetEducatorHomeNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorHomeNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorHomeNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorNotificationHomeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorNotificationHomeDto[]>;
        }));
    }

    protected processGetEducatorHomeNotifications(response: HttpResponseBase): Observable<EducatorNotificationHomeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorNotificationHomeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorNotifications(): Observable<EducatorNotificationDto[]> {
        let url_ = this.baseUrl + "/api/Notifications/GetEducatorNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorNotificationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorNotificationDto[]>;
        }));
    }

    protected processGetEducatorNotifications(response: HttpResponseBase): Observable<EducatorNotificationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorNotificationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markNotificationAsRead(command: MarkNotificationAsReadCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Notifications/MarkNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMarkNotificationAsRead(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PendingApplicationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    fetchPendingApplication(): Observable<PendingApplicationDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/FetchPendingApplication";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFetchPendingApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFetchPendingApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingApplicationDto>;
        }));
    }

    protected processFetchPendingApplication(response: HttpResponseBase): Observable<PendingApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingApplicationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPendingApplication(): Observable<PendingApplicationDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/CreatePendingApplication";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePendingApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePendingApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingApplicationDto>;
        }));
    }

    protected processCreatePendingApplication(response: HttpResponseBase): Observable<PendingApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingApplicationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    skipApplicationToDo(command: SkipApplicationToDoCommand): Observable<PendingApplicationDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/SkipApplicationToDo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSkipApplicationToDo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSkipApplicationToDo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingApplicationDto>;
        }));
    }

    protected processSkipApplicationToDo(response: HttpResponseBase): Observable<PendingApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingApplicationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    syncApplicationToDoItems(command: SyncAppToDoItemsCommand): Observable<PendingToDoItemSummaryDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/SyncApplicationToDoItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncApplicationToDoItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncApplicationToDoItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingToDoItemSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingToDoItemSummaryDto>;
        }));
    }

    protected processSyncApplicationToDoItems(response: HttpResponseBase): Observable<PendingToDoItemSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingToDoItemSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelPendingApplication(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PendingApplication/CancelPendingApplication";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPendingApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPendingApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCancelPendingApplication(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailableVoucherCreditOptionsForService(serviceCode?: string | undefined): Observable<AvailableVoucherCreditOptionDto[]> {
        let url_ = this.baseUrl + "/api/PendingApplication/GetAvailableVoucherCreditOptionsForService?";
        if (serviceCode === null)
            throw new globalThis.Error("The parameter 'serviceCode' cannot be null.");
        else if (serviceCode !== undefined)
            url_ += "serviceCode=" + encodeURIComponent("" + serviceCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableVoucherCreditOptionsForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableVoucherCreditOptionsForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailableVoucherCreditOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailableVoucherCreditOptionDto[]>;
        }));
    }

    protected processGetAvailableVoucherCreditOptionsForService(response: HttpResponseBase): Observable<AvailableVoucherCreditOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AvailableVoucherCreditOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailableCertificates(): Observable<AvailableCertificatesDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/GetAvailableCertificates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableCertificates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableCertificates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailableCertificatesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailableCertificatesDto>;
        }));
    }

    protected processGetAvailableCertificates(response: HttpResponseBase): Observable<AvailableCertificatesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AvailableCertificatesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPendingAddCertificateServiceItem(command: CreatePendingAddCertificateServiceItemCommand): Observable<PendingServiceItemDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/CreatePendingAddCertificateServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePendingAddCertificateServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePendingAddCertificateServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingServiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingServiceItemDto>;
        }));
    }

    protected processCreatePendingAddCertificateServiceItem(response: HttpResponseBase): Observable<PendingServiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingServiceItemDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPendingRenewCertificateServiceItem(command: CreatePendingRenewCertificateServiceItemCommand): Observable<PendingServiceItemDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/CreatePendingRenewCertificateServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePendingRenewCertificateServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePendingRenewCertificateServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingServiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingServiceItemDto>;
        }));
    }

    protected processCreatePendingRenewCertificateServiceItem(response: HttpResponseBase): Observable<PendingServiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingServiceItemDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPendingCopyCertificateServiceItem(command: CreatePendingCopyCertificateServiceItemCommand): Observable<PendingServiceItemDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/CreatePendingCopyCertificateServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePendingCopyCertificateServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePendingCopyCertificateServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingServiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingServiceItemDto>;
        }));
    }

    protected processCreatePendingCopyCertificateServiceItem(response: HttpResponseBase): Observable<PendingServiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingServiceItemDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPendingNameChangeServiceItem(command: CreatePendingNameChangeServiceItemCommand): Observable<PendingServiceItemDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/CreatePendingNameChangeServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePendingNameChangeServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePendingNameChangeServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingServiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingServiceItemDto>;
        }));
    }

    protected processCreatePendingNameChangeServiceItem(response: HttpResponseBase): Observable<PendingServiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingServiceItemDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailableApprovedAreas(): Observable<ApprovedAreaCodeDto[]> {
        let url_ = this.baseUrl + "/api/PendingApplication/GetAvailableApprovedAreas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableApprovedAreas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableApprovedAreas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovedAreaCodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovedAreaCodeDto[]>;
        }));
    }

    protected processGetAvailableApprovedAreas(response: HttpResponseBase): Observable<ApprovedAreaCodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApprovedAreaCodeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApprovedAreasForCertificates(): Observable<ApprovedAreaCodeOptionForAddCertDto[]> {
        let url_ = this.baseUrl + "/api/PendingApplication/GetApprovedAreasForCertificates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovedAreasForCertificates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovedAreasForCertificates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovedAreaCodeOptionForAddCertDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovedAreaCodeOptionForAddCertDto[]>;
        }));
    }

    protected processGetApprovedAreasForCertificates(response: HttpResponseBase): Observable<ApprovedAreaCodeOptionForAddCertDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApprovedAreaCodeOptionForAddCertDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPendingAddApprovedAreaServiceItem(command: CreatePendingAddApprovedAreaServiceItemCommand): Observable<PendingServiceItemDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/CreatePendingAddApprovedAreaServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePendingAddApprovedAreaServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePendingAddApprovedAreaServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingServiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingServiceItemDto>;
        }));
    }

    protected processCreatePendingAddApprovedAreaServiceItem(response: HttpResponseBase): Observable<PendingServiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingServiceItemDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingDeficiencyRemovalServiceItem(): Observable<DeficiencyRemovalPendingServiceItemDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/GetPendingDeficiencyRemovalServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingDeficiencyRemovalServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingDeficiencyRemovalServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeficiencyRemovalPendingServiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeficiencyRemovalPendingServiceItemDto>;
        }));
    }

    protected processGetPendingDeficiencyRemovalServiceItem(response: HttpResponseBase): Observable<DeficiencyRemovalPendingServiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeficiencyRemovalPendingServiceItemDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrUpdatePendingRemoveDeficiencyServiceItem(command: CreateOrUpdatePendingRemoveDeficiencyServiceItemCommand): Observable<PendingServiceItemDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/CreateOrUpdatePendingRemoveDeficiencyServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdatePendingRemoveDeficiencyServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdatePendingRemoveDeficiencyServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingServiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingServiceItemDto>;
        }));
    }

    protected processCreateOrUpdatePendingRemoveDeficiencyServiceItem(response: HttpResponseBase): Observable<PendingServiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingServiceItemDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateApplication(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PendingApplication/ValidateApplication";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processValidateApplication(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPendingAddInstitutionalRecommendationServiceItem(command: CreatePendingAddInstitutionalRecommendationServiceItemCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PendingApplication/CreatePendingAddInstitutionalRecommendationServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePendingAddInstitutionalRecommendationServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePendingAddInstitutionalRecommendationServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreatePendingAddInstitutionalRecommendationServiceItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getQualificationPathQuestions(query: GetQualificationPathQuestionsQuery): Observable<QualificationPathQuestionDto[]> {
        let url_ = this.baseUrl + "/api/PendingApplication/GetQualificationPathQuestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualificationPathQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualificationPathQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationPathQuestionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationPathQuestionDto[]>;
        }));
    }

    protected processGetQualificationPathQuestions(response: HttpResponseBase): Observable<QualificationPathQuestionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QualificationPathQuestionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    submitQualificationPathResponses(command: SubmitQualificationPathResponsesCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PendingApplication/SubmitQualificationPathResponses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitQualificationPathResponses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitQualificationPathResponses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSubmitQualificationPathResponses(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePendingServiceItem(command: DeletePendingServiceItemCommand): Observable<DeletePendingServiceItemDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/DeletePendingServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendingServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendingServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeletePendingServiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeletePendingServiceItemDto>;
        }));
    }

    protected processDeletePendingServiceItem(response: HttpResponseBase): Observable<DeletePendingServiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeletePendingServiceItemDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getQuestionSummary(query: GetQuestionSummaryQuery): Observable<QuestionSummaryDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/GetQuestionSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionSummaryDto>;
        }));
    }

    protected processGetQuestionSummary(response: HttpResponseBase): Observable<QuestionSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadPendingAppDocument(query: GetPendingAppDocumentQuery): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PendingApplication/DownloadPendingAppDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPendingAppDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPendingAppDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadPendingAppDocument(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailableEndorsements(): Observable<PublicEndorsementGroupDto[]> {
        let url_ = this.baseUrl + "/api/PendingApplication/GetAvailableEndorsements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableEndorsements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableEndorsements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicEndorsementGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicEndorsementGroupDto[]>;
        }));
    }

    protected processGetAvailableEndorsements(response: HttpResponseBase): Observable<PublicEndorsementGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicEndorsementGroupDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPendingAddEndorsementServiceItem(command: CreatePendingAddEndorsementServiceItemCommand): Observable<PendingServiceItemDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/CreatePendingAddEndorsementServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePendingAddEndorsementServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePendingAddEndorsementServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingServiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingServiceItemDto>;
        }));
    }

    protected processCreatePendingAddEndorsementServiceItem(response: HttpResponseBase): Observable<PendingServiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingServiceItemDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPendingExtendCertificateServiceItem(command: CreatePendingExtendCertificateServiceItemCommand): Observable<PendingServiceItemDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/CreatePendingExtendCertificateServiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePendingExtendCertificateServiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePendingExtendCertificateServiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingServiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingServiceItemDto>;
        }));
    }

    protected processCreatePendingExtendCertificateServiceItem(response: HttpResponseBase): Observable<PendingServiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingServiceItemDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentRecommendationDetails(): Observable<RecommendationStatusDto> {
        let url_ = this.baseUrl + "/api/PendingApplication/GetCurrentRecommendationDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentRecommendationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentRecommendationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecommendationStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecommendationStatusDto>;
        }));
    }

    protected processGetCurrentRecommendationDetails(response: HttpResponseBase): Observable<RecommendationStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecommendationStatusDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkActivePrepProgramConflict(serviceCode?: string | undefined, certificateTypeCodeId?: number | null | undefined, endorsementCodeId?: number | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/PendingApplication/CheckActivePrepProgramConflict?";
        if (serviceCode === null)
            throw new globalThis.Error("The parameter 'serviceCode' cannot be null.");
        else if (serviceCode !== undefined)
            url_ += "ServiceCode=" + encodeURIComponent("" + serviceCode) + "&";
        if (certificateTypeCodeId !== undefined && certificateTypeCodeId !== null)
            url_ += "CertificateTypeCodeId=" + encodeURIComponent("" + certificateTypeCodeId) + "&";
        if (endorsementCodeId !== undefined && endorsementCodeId !== null)
            url_ += "EndorsementCodeId=" + encodeURIComponent("" + endorsementCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckActivePrepProgramConflict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckActivePrepProgramConflict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processCheckActivePrepProgramConflict(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    manuallyWithdrawFromCohortStudentProgram(command: ManuallyWithdrawFromCohortStudentProgramCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PendingApplication/ManuallyWithdrawFromCohortStudentProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManuallyWithdrawFromCohortStudentProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManuallyWithdrawFromCohortStudentProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processManuallyWithdrawFromCohortStudentProgram(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProfessionalDevelopmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getProfessionalDevelopmentHistory(): Observable<EducatorProfessionalDevelopmentHistoryDto[]> {
        let url_ = this.baseUrl + "/api/ProfessionalDevelopment/GetProfessionalDevelopmentHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalDevelopmentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalDevelopmentHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorProfessionalDevelopmentHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorProfessionalDevelopmentHistoryDto[]>;
        }));
    }

    protected processGetProfessionalDevelopmentHistory(response: HttpResponseBase): Observable<EducatorProfessionalDevelopmentHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorProfessionalDevelopmentHistoryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmployingLeaOptions(): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/ProfessionalDevelopment/GetEmployingLeaOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployingLeaOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployingLeaOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetEmployingLeaOptions(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmploymentInformation(): Observable<EmploymentInformationDto> {
        let url_ = this.baseUrl + "/api/ProfessionalDevelopment/GetEmploymentInformation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmploymentInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmploymentInformationDto>;
        }));
    }

    protected processGetEmploymentInformation(response: HttpResponseBase): Observable<EmploymentInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRenewalProfessionalDevelopmentRequirement(query: GetRenewalProfessionalDevelopmentRequirementQuery): Observable<RenewalProfessionalDevelopmentRequirementDto> {
        let url_ = this.baseUrl + "/api/ProfessionalDevelopment/GetRenewalProfessionalDevelopmentRequirement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRenewalProfessionalDevelopmentRequirement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRenewalProfessionalDevelopmentRequirement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RenewalProfessionalDevelopmentRequirementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RenewalProfessionalDevelopmentRequirementDto>;
        }));
    }

    protected processGetRenewalProfessionalDevelopmentRequirement(response: HttpResponseBase): Observable<RenewalProfessionalDevelopmentRequirementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewalProfessionalDevelopmentRequirementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createProfessionalDevelopmentVerificationRequest(command: CreateProfessionalDevelopmentVerificationRequestCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ProfessionalDevelopment/CreateProfessionalDevelopmentVerificationRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProfessionalDevelopmentVerificationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProfessionalDevelopmentVerificationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCreateProfessionalDevelopmentVerificationRequest(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProfileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEducatorProfileInfo(): Observable<EducatorProfileInfoDto> {
        let url_ = this.baseUrl + "/api/Profile/GetEducatorProfileInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorProfileInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorProfileInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorProfileInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorProfileInfoDto>;
        }));
    }

    protected processGetEducatorProfileInfo(response: HttpResponseBase): Observable<EducatorProfileInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorProfileInfoDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorProfileTests(): Observable<EducatorProfileTestDto[]> {
        let url_ = this.baseUrl + "/api/Profile/GetEducatorProfileTests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorProfileTests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorProfileTests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorProfileTestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorProfileTestDto[]>;
        }));
    }

    protected processGetEducatorProfileTests(response: HttpResponseBase): Observable<EducatorProfileTestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorProfileTestDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorProfileEducation(): Observable<EducatorProfileEducationDto[]> {
        let url_ = this.baseUrl + "/api/Profile/GetEducatorProfileEducation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorProfileEducation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorProfileEducation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducatorProfileEducationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducatorProfileEducationDto[]>;
        }));
    }

    protected processGetEducatorProfileEducation(response: HttpResponseBase): Observable<EducatorProfileEducationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducatorProfileEducationDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonsAddressInfo(): Observable<PersonAddressDto> {
        let url_ = this.baseUrl + "/api/Profile/GetPersonsAddressInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonsAddressInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonsAddressInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonAddressDto>;
        }));
    }

    protected processGetPersonsAddressInfo(response: HttpResponseBase): Observable<PersonAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonAddressDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonsAddressInfoExists(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Profile/GetPersonsAddressInfoExists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonsAddressInfoExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonsAddressInfoExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetPersonsAddressInfoExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonsPhoneInfo(): Observable<PersonPhoneDto[]> {
        let url_ = this.baseUrl + "/api/Profile/GetPersonsPhoneInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonsPhoneInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonsPhoneInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonPhoneDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonPhoneDto[]>;
        }));
    }

    protected processGetPersonsPhoneInfo(response: HttpResponseBase): Observable<PersonPhoneDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonPhoneDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPersonsEmailInfo(): Observable<PersonEmailDto[]> {
        let url_ = this.baseUrl + "/api/Profile/GetPersonsEmailInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonsEmailInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonsEmailInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonEmailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonEmailDto[]>;
        }));
    }

    protected processGetPersonsEmailInfo(response: HttpResponseBase): Observable<PersonEmailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonEmailDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPersonsAddress(command: AddOrUpdatePersonsAddressCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Profile/AddPersonsAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPersonsAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPersonsAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddPersonsAddress(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePersonsAddress(command: AddOrUpdatePersonsAddressCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Profile/UpdatePersonsAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonsAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonsAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdatePersonsAddress(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPersonsPhone(command: AddOrUpdatePersonsPhoneCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Profile/AddPersonsPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPersonsPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPersonsPhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddPersonsPhone(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePersonsPhone(command: AddOrUpdatePersonsPhoneCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Profile/UpdatePersonsPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonsPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonsPhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdatePersonsPhone(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePersonsPhone(command: DeletePersonsPhoneCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Profile/DeletePersonsPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePersonsPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePersonsPhone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeletePersonsPhone(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPersonsEmail(command: AddOrUpdatePersonsEmailCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Profile/AddPersonsEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPersonsEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPersonsEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddPersonsEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePersonsEmail(command: AddOrUpdatePersonsEmailCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Profile/UpdatePersonsEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonsEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonsEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdatePersonsEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePersonsEmail(command: DeletePersonsEmailCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Profile/DeletePersonsEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePersonsEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePersonsEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeletePersonsEmail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PublicPortalClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchEducator(searchQuery: GetPublicEducatorSearchQuery): Observable<PublicSearchEducatorDto> {
        let url_ = this.baseUrl + "/api/PublicPortal/SearchEducator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchEducator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchEducator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicSearchEducatorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicSearchEducatorDto>;
        }));
    }

    protected processSearchEducator(response: HttpResponseBase): Observable<PublicSearchEducatorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicSearchEducatorDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorPositions(): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/PublicPortal/GetEducatorPositions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorPositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorPositions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetEducatorPositions(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTeachingGrades(): Observable<SimpleCodeDescriptionDto[]> {
        let url_ = this.baseUrl + "/api/PublicPortal/GetTeachingGrades";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeachingGrades(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeachingGrades(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleCodeDescriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleCodeDescriptionDto[]>;
        }));
    }

    protected processGetTeachingGrades(response: HttpResponseBase): Observable<SimpleCodeDescriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleCodeDescriptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEducatorCertificateDetail(personId?: number | undefined): Observable<PublicEducatorCertificateDetailDto> {
        let url_ = this.baseUrl + "/api/PublicPortal/GetEducatorCertificateDetail?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducatorCertificateDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducatorCertificateDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicEducatorCertificateDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicEducatorCertificateDetailDto>;
        }));
    }

    protected processGetEducatorCertificateDetail(response: HttpResponseBase): Observable<PublicEducatorCertificateDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicEducatorCertificateDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadGlossaryOfTerms(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PublicPortal/DownloadGlossaryOfTerms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadGlossaryOfTerms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadGlossaryOfTerms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadGlossaryOfTerms(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    newSearchEducator(searchQuery: NewPublicEducatorSearchQuery): Observable<PublicSearchEducatorDto> {
        let url_ = this.baseUrl + "/api/PublicPortal/NewSearchEducator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewSearchEducator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewSearchEducator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicSearchEducatorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicSearchEducatorDto>;
        }));
    }

    protected processNewSearchEducator(response: HttpResponseBase): Observable<PublicSearchEducatorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicSearchEducatorDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositionCodeOptions(): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/PublicPortal/GetPositionCodeOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositionCodeOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositionCodeOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetPositionCodeOptions(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGradeLevelCodeOptions(): Observable<SimpleSelectOptionDto[]> {
        let url_ = this.baseUrl + "/api/PublicPortal/GetGradeLevelCodeOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGradeLevelCodeOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGradeLevelCodeOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSelectOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSelectOptionDto[]>;
        }));
    }

    protected processGetGradeLevelCodeOptions(response: HttpResponseBase): Observable<SimpleSelectOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleSelectOptionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPublicEducatorCredentials(personId?: number | undefined): Observable<PublicEducatorCredentialsResultDto> {
        let url_ = this.baseUrl + "/api/PublicPortal/GetPublicEducatorCredentials?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicEducatorCredentials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicEducatorCredentials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicEducatorCredentialsResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicEducatorCredentialsResultDto>;
        }));
    }

    protected processGetPublicEducatorCredentials(response: HttpResponseBase): Observable<PublicEducatorCredentialsResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicEducatorCredentialsResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGlossaryOfTerms(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PublicPortal/GetGlossaryOfTerms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlossaryOfTerms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlossaryOfTerms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetGlossaryOfTerms(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class QuestionGroupsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getOnFileEducatorDegrees(): Observable<OnFileEducatorDegreeDto[]> {
        let url_ = this.baseUrl + "/api/QuestionGroups/GetOnFileEducatorDegrees";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnFileEducatorDegrees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnFileEducatorDegrees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnFileEducatorDegreeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnFileEducatorDegreeDto[]>;
        }));
    }

    protected processGetOnFileEducatorDegrees(response: HttpResponseBase): Observable<OnFileEducatorDegreeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnFileEducatorDegreeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingApplicationDegrees(): Observable<PendingApplicationDegreeDto[]> {
        let url_ = this.baseUrl + "/api/QuestionGroups/GetPendingApplicationDegrees";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingApplicationDegrees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingApplicationDegrees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingApplicationDegreeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingApplicationDegreeDto[]>;
        }));
    }

    protected processGetPendingApplicationDegrees(response: HttpResponseBase): Observable<PendingApplicationDegreeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingApplicationDegreeDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPendingApplicationDegree(command: AddPendingApplicationDegreeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/AddPendingApplicationDegree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPendingApplicationDegree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPendingApplicationDegree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddPendingApplicationDegree(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePendingApplicationDegree(command: DeletePendingApplicationDegreeCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/DeletePendingApplicationDegree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendingApplicationDegree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendingApplicationDegree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeletePendingApplicationDegree(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeDegreeInfoQuestionGroup(command: CompleteDegreeInfoQuestionGroupCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/CompleteDegreeInfoQuestionGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteDegreeInfoQuestionGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteDegreeInfoQuestionGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCompleteDegreeInfoQuestionGroup(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOnFileEducatorTests(): Observable<OnFileEducatorTestDto[]> {
        let url_ = this.baseUrl + "/api/QuestionGroups/GetOnFileEducatorTests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnFileEducatorTests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnFileEducatorTests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnFileEducatorTestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnFileEducatorTestDto[]>;
        }));
    }

    protected processGetOnFileEducatorTests(response: HttpResponseBase): Observable<OnFileEducatorTestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnFileEducatorTestDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingApplicationTests(): Observable<PendingApplicationTestDto[]> {
        let url_ = this.baseUrl + "/api/QuestionGroups/GetPendingApplicationTests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingApplicationTests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingApplicationTests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingApplicationTestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingApplicationTestDto[]>;
        }));
    }

    protected processGetPendingApplicationTests(response: HttpResponseBase): Observable<PendingApplicationTestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingApplicationTestDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPendingApplicationTest(command: AddPendingApplicationTestCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/AddPendingApplicationTest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPendingApplicationTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPendingApplicationTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddPendingApplicationTest(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePendingApplicationTest(command: DeletePendingApplicationTestCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/DeletePendingApplicationTest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendingApplicationTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendingApplicationTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeletePendingApplicationTest(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeTestInfoQuestionGroup(command: CompleteTestInfoQuestionGroupCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/CompleteTestInfoQuestionGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteTestInfoQuestionGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteTestInfoQuestionGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCompleteTestInfoQuestionGroup(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingApplicationReciprocityCertificates(): Observable<PendingApplicationReciprocityCertificateDto[]> {
        let url_ = this.baseUrl + "/api/QuestionGroups/GetPendingApplicationReciprocityCertificates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingApplicationReciprocityCertificates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingApplicationReciprocityCertificates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingApplicationReciprocityCertificateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingApplicationReciprocityCertificateDto[]>;
        }));
    }

    protected processGetPendingApplicationReciprocityCertificates(response: HttpResponseBase): Observable<PendingApplicationReciprocityCertificateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingApplicationReciprocityCertificateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPendingApplicationReciprocityCertificate(command: AddPendingApplicationReciprocityCertificateCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/AddPendingApplicationReciprocityCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPendingApplicationReciprocityCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPendingApplicationReciprocityCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddPendingApplicationReciprocityCertificate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePendingApplicationReciprocityCertificate(command: DeletePendingApplicationReciprocityCertificateCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/DeletePendingApplicationReciprocityCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendingApplicationReciprocityCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendingApplicationReciprocityCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeletePendingApplicationReciprocityCertificate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeReciprocityCertificateInfoQuestionGroup(command: CompleteReciprocityCertificateInfoQuestionGroupCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/CompleteReciprocityCertificateInfoQuestionGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteReciprocityCertificateInfoQuestionGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteReciprocityCertificateInfoQuestionGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCompleteReciprocityCertificateInfoQuestionGroup(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingApplicationPreKTeachingExperiences(): Observable<PendingApplicationPreKTeachingExperienceDto[]> {
        let url_ = this.baseUrl + "/api/QuestionGroups/GetPendingApplicationPreKTeachingExperiences";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingApplicationPreKTeachingExperiences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingApplicationPreKTeachingExperiences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingApplicationPreKTeachingExperienceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingApplicationPreKTeachingExperienceDto[]>;
        }));
    }

    protected processGetPendingApplicationPreKTeachingExperiences(response: HttpResponseBase): Observable<PendingApplicationPreKTeachingExperienceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingApplicationPreKTeachingExperienceDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPendingApplicationPreKTeachingExperience(command: AddPendingApplicationPreKTeachingExperienceCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/AddPendingApplicationPreKTeachingExperience";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPendingApplicationPreKTeachingExperience(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPendingApplicationPreKTeachingExperience(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddPendingApplicationPreKTeachingExperience(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePendingApplicationPreKTeachingExperience(command: DeletePendingApplicationPreKTeachingExperienceCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/DeletePendingApplicationPreKTeachingExperience";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendingApplicationPreKTeachingExperience(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendingApplicationPreKTeachingExperience(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeletePendingApplicationPreKTeachingExperience(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completePreKTeachingExperienceInfoQuestionGroup(command: CompletePreKTeachingExperienceInfoQuestionGroupCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/CompletePreKTeachingExperienceInfoQuestionGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletePreKTeachingExperienceInfoQuestionGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePreKTeachingExperienceInfoQuestionGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCompletePreKTeachingExperienceInfoQuestionGroup(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingApplicationCteExperiences(): Observable<PendingApplicationCteExperienceDto[]> {
        let url_ = this.baseUrl + "/api/QuestionGroups/GetPendingApplicationCteExperiences";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingApplicationCteExperiences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingApplicationCteExperiences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingApplicationCteExperienceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingApplicationCteExperienceDto[]>;
        }));
    }

    protected processGetPendingApplicationCteExperiences(response: HttpResponseBase): Observable<PendingApplicationCteExperienceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingApplicationCteExperienceDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPendingApplicationCteExperience(command: AddPendingApplicationCteExperienceCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/AddPendingApplicationCteExperience";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPendingApplicationCteExperience(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPendingApplicationCteExperience(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddPendingApplicationCteExperience(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePendingApplicationCteExperience(command: DeletePendingApplicationCteExperienceCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/DeletePendingApplicationCteExperience";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendingApplicationCteExperience(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendingApplicationCteExperience(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeletePendingApplicationCteExperience(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeCteExperienceInfoQuestionGroup(command: CompleteCteExperienceInfoQuestionGroupCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/CompleteCteExperienceInfoQuestionGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteCteExperienceInfoQuestionGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteCteExperienceInfoQuestionGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCompleteCteExperienceInfoQuestionGroup(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingApplicationCoursework(): Observable<PendingApplicationCourseworkDto[]> {
        let url_ = this.baseUrl + "/api/QuestionGroups/GetPendingApplicationCoursework";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingApplicationCoursework(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingApplicationCoursework(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingApplicationCourseworkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingApplicationCourseworkDto[]>;
        }));
    }

    protected processGetPendingApplicationCoursework(response: HttpResponseBase): Observable<PendingApplicationCourseworkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingApplicationCourseworkDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPendingApplicationCoursework(command: AddPendingApplicationCourseworkCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/AddPendingApplicationCoursework";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPendingApplicationCoursework(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPendingApplicationCoursework(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddPendingApplicationCoursework(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePendingApplicationCoursework(command: DeletePendingApplicationCourseworkCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/DeletePendingApplicationCoursework";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendingApplicationCoursework(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendingApplicationCoursework(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeletePendingApplicationCoursework(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeCourseworkInfoQuestionGroup(command: CompleteCourseworkInfoQuestionGroupCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/CompleteCourseworkInfoQuestionGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteCourseworkInfoQuestionGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteCourseworkInfoQuestionGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCompleteCourseworkInfoQuestionGroup(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingApplicationLeadership(): Observable<PendingApplicationLeadershipDto[]> {
        let url_ = this.baseUrl + "/api/QuestionGroups/GetPendingApplicationLeadership";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingApplicationLeadership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingApplicationLeadership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingApplicationLeadershipDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingApplicationLeadershipDto[]>;
        }));
    }

    protected processGetPendingApplicationLeadership(response: HttpResponseBase): Observable<PendingApplicationLeadershipDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingApplicationLeadershipDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPendingApplicationLeadership(command: AddPendingApplicationLeadershipCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/AddPendingApplicationLeadership";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPendingApplicationLeadership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPendingApplicationLeadership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddPendingApplicationLeadership(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePendingApplicationLeadership(command: DeletePendingApplicationLeadershipCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/DeletePendingApplicationLeadership";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendingApplicationLeadership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendingApplicationLeadership(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeletePendingApplicationLeadership(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeLeadershipInfoQuestionGroup(command: CompleteLeadershipInfoQuestionGroupCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/CompleteLeadershipInfoQuestionGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteLeadershipInfoQuestionGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteLeadershipInfoQuestionGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processCompleteLeadershipInfoQuestionGroup(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addRequiredDocuments(command: AddRequiredDocumentsCommand): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/QuestionGroups/AddRequiredDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRequiredDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRequiredDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAddRequiredDocuments(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPendingApplicationRequiredDocuments(query: GetPendingApplicationRequiredDocumentsQuery): Observable<PendingApplicationRequiredDocumentDto[]> {
        let url_ = this.baseUrl + "/api/QuestionGroups/GetPendingApplicationRequiredDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingApplicationRequiredDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingApplicationRequiredDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingApplicationRequiredDocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingApplicationRequiredDocumentDto[]>;
        }));
    }

    protected processGetPendingApplicationRequiredDocuments(response: HttpResponseBase): Observable<PendingApplicationRequiredDocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PendingApplicationRequiredDocumentDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface LogApplicationEventCommand {
    level: LogLevel;
    payload: Payload;
    commandQueryName?: string | undefined;
}

export enum LogLevel {
    Trace = 0,
    Debug = 1,
    Information = 2,
    Warning = 3,
    Error = 4,
    Critical = 5,
    None = 6,
}

export interface TokenExchangeDto {
    localToken?: string | undefined;
    wasExchanged: boolean;
    isEducatorCorrelated: boolean;
    wasPendingAppClearedSinceLastLogin: boolean;
}

export interface ExchangeIdpTokenCommand {
    idpIdentityToken: string;
}

export interface CreateNonProdUserTokenCommand {
    ein: string;
}

export interface TokenRefreshResult {
    token: string;
    wasRefreshed: boolean;
}

export interface UserLogoutCommand {
    userId?: number | undefined;
}

export interface EducatorEINDto {
    name: string;
    alternateNames: string[];
    ssn: string;
    ein: string;
    phoneNumbers: string[];
    dateOfBirth: string;
    zipCode: string;
    fingerprintCardNumber: string;
    otherZipCodes: string[];
    display: string;
}

export interface GetEducatorEINsQuery {
    einSearch: string;
}

export interface EducatorInfoDto {
    name?: string | undefined;
    ein?: string | undefined;
    isConfirmed: boolean;
}

export interface EducatorVerificationStepOneCommand {
    ssn?: string | undefined;
    dateOfBirth?: Date | undefined;
}

export interface EducatorVerificationInformationDto {
    fingerprintCardOnFile: boolean;
    contactInfoOnFile: boolean;
}

export interface EducatorVerificationStepTwoDpsCommand {
    fingerprintCardNumber?: string | undefined;
}

export interface EducatorVerificationStepTwoContactCommand {
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    zipCode?: string | undefined;
}

export interface PendingApplicationBackgroundCheckResponseDto {
    backgroundCheckQuestionResponseId?: number | undefined;
    pendingApplicationId: number;
    questionKey: string;
    questionText: string;
    response?: boolean | undefined;
    questionType: BackgroundCheckQuestionType;
    backgroundCheckQuestionResponseData: BackgroundCheckQuestionResponseData;
}

export enum BackgroundCheckQuestionType {
    AffectingLicensure = 0,
    CriminalType = 1,
    DCS = 2,
}

export interface BackgroundCheckQuestionResponseData {
    detailsAffectingLicensure: BackgroundQuestionAffectingLicensureDetailData[];
    criminalTypeDetails: BackgroundQuestionCriminalTypeDetailData[];
    dcsDetails: BackgroundQuestionDcsDetailData[];
}

export interface BackgroundQuestionAffectingLicensureDetailData {
    typeOfDisciplineOrReprimand?: string | undefined;
    lengthOfDisciplinaryPeriod?: string | undefined;
    disciplineIssuingAgency?: string | undefined;
    issuanceDate?: string | undefined;
    issuanceState?: string | undefined;
    allegationsOfMisconduct?: string | undefined;
    descriptionOfCircumstances?: string | undefined;
    currentStatusOfDisciplinaryAction?: string | undefined;
}

export interface BackgroundQuestionCriminalTypeDetailData {
    dateOfArrest?: string | undefined;
    cityOfArrest?: string | undefined;
    stateOfArrest?: string | undefined;
    nameOfOffense?: string | undefined;
    descriptionOfCircumstances?: string | undefined;
    dispositionOfCase?: string | undefined;
    mitigatingFactors?: string | undefined;
    sentencingInformation?: string | undefined;
}

export interface BackgroundQuestionDcsDetailData {
    typeOfDisciplineOrReprimand?: string | undefined;
    lengthOfDisciplinaryPeriod?: string | undefined;
    agencyInvestigatingAllegations?: string | undefined;
    dateOfInvestigation?: string | undefined;
    allegations?: string | undefined;
    descriptionOfCircumstances?: string | undefined;
    currentStatusOfInvestigation?: string | undefined;
}

export interface AddOrUpdateBackgroundCheckQuestionResponsesCommand {
    questionResponses: UpsertBackgroundCheckQuestionResponseDto[];
}

export interface UpsertBackgroundCheckQuestionResponseDto {
    questionKey: string;
    questionText: string;
    response?: boolean | undefined;
    questionType: BackgroundCheckQuestionType;
    backgroundCheckQuestionResponseData: BackgroundCheckQuestionResponseData;
}

export interface EducatorCertificateDto {
    personCertificateId: number;
    certificateDescription: string;
    restrictedApprovedAreaDescription?: string | undefined;
    status: string;
    issueDate?: Date | undefined;
    expireDate?: Date | undefined;
    isRenewable: boolean;
    details: EducatorCertificateDetails;
    reissuanceReminders: string[];
    isActionable: boolean;
    hasMetProfessionalDevelopmentRequirement: boolean;
}

export interface EducatorCertificateDetails {
    applicableAreaDescriptions?: string | undefined;
    applicableEndorsementDescriptions?: string | undefined;
    allowableDeficiencies: EducatorCertificateAllowableDeficiencyDto[];
    ppiDescription?: string | undefined;
    leaDescription?: string | undefined;
}

export interface EducatorCertificateAllowableDeficiencyDto {
    allowableDeficiencyCodeId: number;
    description: string;
    startDate: Date;
    endDate: Date;
}

export interface StateDto {
    stateCodeId: number;
    stateCode: string;
    description: string;
}

export interface PhoneCodeDto {
    phoneCodeId: number;
    code: string;
    description: string;
    isDisabled: boolean;
}

export interface EmailCodeDto {
    emailCodeId: number;
    code: string;
    description: string;
    isDisabled: boolean;
}

export interface ContactTypeCodeDto {
    contactTypeCodeId: number;
    code: string;
    description: string;
}

export interface LocationCodeDto {
    locationCodeId: number;
    code: string;
    description: string;
}

export interface SimpleSelectOptionDto {
    id: number;
    description: string;
}

export interface SimpleCodeDescriptionDto extends SimpleSelectOptionDto {
    code: string;
}

export interface ApprovedAreaCodeDto extends SimpleCodeDescriptionDto {
    relevantCertificateTypeCodeIds: number[];
}

export interface ApplicationSummaryDto {
    clientHtml: string;
    attestationConfirmed: boolean;
}

export interface PaymentSummaryDto {
    lineItems: PaymentSummaryLineItemDto[];
    total: number;
    creditApplied: number;
    voucherCreditApplied: number;
    voucherCreditsApplied: number[];
    summaryReferenceId: string;
}

export interface PaymentSummaryLineItemDto {
    serviceCodeDescription: string;
    description: string;
    hasATAWaiver: boolean;
    amount: number;
    pendingServiceItemId: number;
}

export interface SnapPayPaymentRequestModel {
    firstName: string;
    lastName: string;
    transactionAmount: string;
    currencyCode: string;
    paymentMode: string;
    email: string;
    signature: string;
    accountId: string;
    customerId: string;
    merchantId: string;
    redirectionUrl: string;
    udf0: string;
    phoneNumber: string;
    streetAddress?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    hppUrl: string;
    country?: string | undefined;
}

export interface CreatePaymentRequestCommand {
    summaryReferenceId: string;
    paymentMode: PaymentMode;
}

export enum PaymentMode {
    CC = 0,
    ACH = 1,
}

export enum PendingPaymentStatus {
    NotCreated = 0,
    IncompleteAtProvider = 1,
    CompleteAtProvider = 2,
    Finalized = 3,
}

export interface SnapPayPaymentResponseModel {
    accountId?: string | undefined;
    customerId?: string | undefined;
    companyCode?: string | undefined;
    currencyCode?: string | undefined;
    merchantId?: string | undefined;
    paymentTransactionId?: string | undefined;
    pgTransactionId?: string | undefined;
    transactionAmount?: string | undefined;
    authorizationNumber?: string | undefined;
    returnMessage?: string | undefined;
    transactionStatus?: string | undefined;
    pgReturnCode?: string | undefined;
    pgReturnDescription?: string | undefined;
    transactionDate?: string | undefined;
    respproc?: string | undefined;
    userFields?: string | undefined;
    pgText?: string | undefined;
    paymentMethodType?: string | undefined;
    paymentMethodLast4?: string | undefined;
    paymentMethodToken?: string | undefined;
    paymentMethodFirstName?: string | undefined;
    paymentMethodLastName?: string | undefined;
    paymentMethodExpirationMonth?: string | undefined;
    paymentMethodExpirationYear?: string | undefined;
    paymentMethodRoutingNumber?: string | undefined;
    paymentMethodAddressLine1?: string | undefined;
    paymentMethodCity?: string | undefined;
    paymentMethodState?: string | undefined;
    paymentMethodZip?: string | undefined;
    paymentMethodCountry?: string | undefined;
    paymentMethodEmail?: string | undefined;
    paymentMethodPhoneNumber?: string | undefined;
    feePgTransactionId?: string | undefined;
    feeAmount?: string | undefined;
    feeAuthorizationNumber?: string | undefined;
    feeTransactionStatus?: string | undefined;
    feePgReturnCode?: string | undefined;
    feePgReturnDescription?: string | undefined;
    feeTransactionDate?: string | undefined;
    feeRespproc?: string | undefined;
    feePgText?: string | undefined;
    feePaymentTransactionId?: string | undefined;
    feeFormat?: string | undefined;
    feeType?: string | undefined;
    feeValue?: string | undefined;
    signature?: string | undefined;
    udf0?: string | undefined;
    udf1?: string | undefined;
    udf2?: string | undefined;
    udf3?: string | undefined;
    udf4?: string | undefined;
    udf5?: string | undefined;
    udf6?: string | undefined;
    udf7?: string | undefined;
    udf8?: string | undefined;
    udf9?: string | undefined;
}

export interface SubmitFreeApplicationCommand {
    summaryReferenceId: string;
}

export interface ApplicationCompleteStateDto {
    hasBackgroundQuestionResponses: boolean;
    hasAttestationConfirmed: boolean;
}

export interface EdPortalClientConfig {
    environment?: string | undefined;
    idleTimeoutInSeconds: number;
    azureAppConfig: AzureAppConfig;
    testModeAllowed: boolean;
    certHubUrl?: string | undefined;
}

export interface AzureAppConfig {
    issuer: string;
    authority: string;
    metadataUrl: string;
    clientId: string;
    redirectUri: string;
    postLogoutRedirectUri: string;
}

export interface FeatureManagement {
    caseIQ: boolean;
    sharePointUpload: boolean;
    edPortalPayments: boolean;
    educatorNotifications: boolean;
    dpsFileCleanup: boolean;
    testFileCleanup: boolean;
    informationObscurity: boolean;
    achPayment: boolean;
    edPortalTour: boolean;
    deleteCertificates: boolean;
    substantivelyComplete: boolean;
    transcriptImport: boolean;
    einConflictResolution: boolean;
    certificationContacts: boolean;
    leaRoster: boolean;
    leaInformation: boolean;
    stakeholderIdGeneration: boolean;
    lea1Portal: boolean;
    lea2Portal: boolean;
    credentialConfiguration: boolean;
    lea2BatchUpload: boolean;
    lea2DpsBackgroundAlerts: boolean;
    lea2InitialFYLegacyPositionBatchUpload: boolean;
    lea2WorkforceBatchUpload: boolean;
    lea2WorkforceManagement: boolean;
    legacyLea2Workforce: boolean;
    mismatchedFingerprintReport: boolean;
    immediatePrint: boolean;
    eppManagement: boolean;
    evaluationQualificationPathTool: boolean;
    leaRush: boolean;
    workforceInformation: boolean;
    acEvaluation: boolean;
    bulkACReevaluation: boolean;
    surveys: boolean;
    emails: boolean;
    leaYearTransition: boolean;
    reports: boolean;
    vouchers: boolean;
    retroactiveVouchers: boolean;
    vouchersFirstComeFirstServeDistribution: boolean;
    complexProfessionalDevelopment: boolean;
    evaluationCommunication: boolean;
    screenShare: boolean;
}

export interface ReportErrorCommand {
    site: string;
    errorId: string;
    traceId: string;
}

export interface ExistingDeficiencyDto extends SimpleCodeDescriptionDto {
    startDate: Date;
    endDate: Date;
}

export interface CertificateRenewalContextDto {
    personCertificateId: number;
    certificateDescription: string;
    issueDate: Date;
    expireDate: Date;
    canBeAligned: boolean;
    renewalSelectionType: RenewalSelectionType;
}

export enum RenewalSelectionType {
    NotEligible = 0,
    StandardRenewal = 1,
    TenTwoRenewal = 2,
}

export interface CurrentNameDto {
    currentFirstName: string;
    currentMiddleName?: string | undefined;
    currentLastName: string;
}

export interface CertificateForCopyOfCertDto {
    personCertificateId: number;
    certificateDescription: string;
}

export interface ValidInstitutionalRecommendationDto {
    personPPIRecommendationId: number;
    programDescription: string;
    issueDate: string;
    irCertificates: ValidIRCertificateDto[];
    irEndorsements: ValidIRCertificateEndorsementDto[];
}

export interface ValidIRCertificateDto {
    personPPIRecommendedCertificateId: number;
    certificateDescription: string;
    areaDescription?: string | undefined;
    isChecked: boolean;
}

export interface ValidIRCertificateEndorsementDto {
    personPPIRecommendedCertificateEndorsementCodeId: number;
    personPPIRecommendedCertificateId: number;
    description: string;
    endorsementCode?: string | undefined;
    requirementDescription?: string | undefined;
    isChecked: boolean;
}

export interface OwnedEndorsementDto {
    endorsementCodeDescription: string;
    endorsementLevelDescription: string;
}

export interface ExtendableCertificateDto {
    personCertificateId: number;
    certificateDescription: string;
    issueDate: Date;
    expireDate: Date;
    isInternational: boolean;
}

export interface UploadDocumentCommand {
    documentDescription?: string | undefined;
    content?: string | undefined;
}

export interface EducatorDocumentResultDto {
    personDocumentId?: number | undefined;
    description: string;
    reviewStatusDescription: string;
    isUploadedByEducator: boolean;
    uploadDate: Date;
}

export interface EducatorApplicationDto {
    applicationId: number;
    personId: number;
    applicationStatus?: string | undefined;
    createdDate: Date;
    createdBy?: string | undefined;
    modifiedDate?: Date | undefined;
    modifiedBy?: string | undefined;
    receiptNumber?: string | undefined;
    paymentId?: number | undefined;
    documentFileName?: string | undefined;
    personDocumentId?: number | undefined;
    services?: ApplicationServiceSummaryItem[] | undefined;
}

export interface ApplicationServiceSummaryItem {
    applicationServiceItemId: number;
    serviceCodeDescription: string;
    itemDescription?: string | undefined;
    itemSubDescription?: string | undefined;
    status: ServiceStatus;
    statusDescription: string;
    isOnHold: boolean;
    holdingAge: number;
    phase: number;
    hasAllowableDeficiencies: boolean;
    statusHasIssue: boolean;
    phaseStatusDescription: string;
    hasEvaluation: boolean;
    daysInCurrentStatus: number;
    modifiedDate?: Date | undefined;
    statusRequiresEducatorAction: boolean;
    evaluationCommunicationCount: number;
}

export enum ServiceStatus {
    Building = 0,
    Received = 1,
    AdministrativeReview = 2,
    AdministrativeIncomplete = 3,
    SubstantiveReview = 4,
    SubstantiveIncomplete = 5,
    FinalSIReview = 6,
    InvestigativeReviewPending = 7,
    InvestigativeReview = 8,
    Qualified = 9,
    SIReturned = 10,
    Appealed = 11,
    Issued = 12,
    AdministrativelyWithdrawn = 13,
    Denied = 14,
    Holding = 15,
    ReturnedIncomplete = 16,
    Cancelled = 17,
    Closed = 18,
}

export interface EdPortalServiceItemEvaluationDto {
    applicationServiceItemEvaluationId?: number | undefined;
    applicationServiceItemId: number;
    serviceItemItemDescription: string;
    applicationId: number;
    evaluationId: number;
    evaluationDescription: string;
    serviceCodeDescription: string;
    applicationCreatedDate: Date;
    modifiedDate: Date;
    isStatusBeyondAdministrative: boolean;
    serviceStatus: ServiceStatus;
    serviceStatusDescription: string;
    daysInCurrentStatus: number;
    isStatusFinalized: boolean;
    statusHasIssue: boolean;
    statusRequiresEducatorAction: boolean;
    whatThisMeansText?: string | undefined;
    explanation?: string | undefined;
    helperText?: string | undefined;
    evaluationCompletedPercent?: number | undefined;
    multipleEvaluationsExist: boolean;
    clientServiceItemEvaluationRequirements: EdPortalServiceItemEvalRequirementDto[];
}

export interface EdPortalServiceItemEvalRequirementDto {
    applicationServiceItemEvaluationRequirementId?: number | undefined;
    requirementId: number;
    title?: string | undefined;
    requirementType: RequirementType;
    order: number;
    clientSubRequirements: EdPortalServiceItemEvaluationSubRequirementDto[];
    clientSubRequirementGroups: EdPortalServiceItemEvaluationSubRequirementGroupDto[];
    hasAllowableDeficiency: boolean;
    isSatisfied: boolean;
    requirementIncompleteReasonId?: number | undefined;
    requirementIncompleteReasonDescription?: string | undefined;
    modifiedDate: Date;
    evaluationDetails?: string | undefined;
    helperText?: string | undefined;
    explanation?: string | undefined;
    customIncompleteReason?: string | undefined;
}

export enum RequirementType {
    Administrative = 0,
    Substantive = 1,
}

export interface EdPortalServiceItemEvaluationSubRequirementDto {
    applicationServiceItemEvaluationSubRequirementId?: number | undefined;
    subRequirementId: number;
    title?: string | undefined;
    order: number;
    parentRequirementId?: number | undefined;
    parentSubRequirementGroupId?: number | undefined;
    isSatisfied: boolean;
    hasAllowableDeficiency: boolean;
    subRequirementIncompleteReasonId?: number | undefined;
    subRequirementIncompleteReasonDescription?: string | undefined;
    evaluationDetails?: string | undefined;
    modifiedDate: Date;
    helperText?: string | undefined;
    explanation?: string | undefined;
    customIncompleteReason?: string | undefined;
}

export interface EdPortalServiceItemEvaluationSubRequirementGroupDto {
    subRequirementGroupId: number;
    description?: string | undefined;
    order: number;
    subRequirementGroupType: SubRequirementGroupType;
    parentRequirementId?: number | undefined;
    parentSubRequirementGroupId?: number | undefined;
    selectedSubRequirementId?: number | undefined;
    isSatisfied: boolean;
    clientSubRequirements: EdPortalServiceItemEvaluationSubRequirementDto[];
    clientSubRequirementGroups: EdPortalServiceItemEvaluationSubRequirementGroupDto[];
}

export enum SubRequirementGroupType {
    Alternative = 0,
    Composite = 1,
}

export interface AddEducatorAdditionalDocumentCommand {
    documentDescription?: string | undefined;
    content?: string | undefined;
}

export interface ServiceItemEvaluationTimelineItemDto {
    eventType: EvaluationTimelineEventType;
    requiresEducatorAction: boolean;
    subject: string;
    message: string;
    timestamp: Date;
    personDocumentId?: number | undefined;
    evaluationCommunicationImageIds: number[];
}

export enum EvaluationTimelineEventType {
    StatusChange = 0,
    HoldBegin = 1,
    HoldEnded = 2,
    MaterialReceived = 3,
    EvaluationCommunication = 4,
    CertificatePrinted = 5,
    DecisionComplete = 6,
    ProfessionalDevelopmentRecorded = 7,
}

export interface ToDoBaseDto {
    type: ToDoTaskType;
    deficiencyRemovalPayload?: DeficiencyRemovalToDoItemPayload | undefined;
    renewalPayload?: RenewalToDoItemPayload | undefined;
    institutionalRecommendationPayload?: InstitutionalRecommendationToDoItemPayload | undefined;
    voucherCreditPayload?: VoucherCreditToDoItemPayload | undefined;
    evaluationIssuePayload?: EvaluationIssueToDoItemPayload | undefined;
}

export interface EducatorToDoTaskDto extends ToDoBaseDto {
    typeDescription: string;
    shortDescription: string;
    longDescription: string;
    taskDetails: ToDoTaskDeficiencyDetail[];
    isFulfilledViaApplication: boolean;
    hasApplicableVoucherCredit: boolean;
}

export interface ToDoTaskDeficiencyDetail {
    deficiencyDescription: string;
    deficiencyAllowedUntilDateHasPassed: boolean;
    dateDetail: string;
}

export enum ToDoTaskType {
    FingerprintExpiringSoon = 0,
    FingerprintExpired = 1,
    W9Required = 2,
    DeficiencyRemoval = 3,
    CertificateRenewal = 4,
    IR = 5,
    VoucherCredit = 6,
    EvaluationIssue = 7,
}

export interface DeficiencyRemovalToDoItemPayload {
    allowableDeficiencyCodeIds: number[];
}

export interface RenewalToDoItemPayload {
    personCertificateId: number;
}

export interface InstitutionalRecommendationToDoItemPayload {
    personPPIRecommendationId: number;
}

export interface VoucherCreditToDoItemPayload {
    serviceCode: string;
}

export interface EvaluationIssueToDoItemPayload {
    applicationServiceItemId: number;
}

export interface EducatorNotificationHomeDto {
    educatorNotificationId: number;
    personDocumentId?: number | undefined;
    description?: string | undefined;
    showPersonDocument: boolean;
}

export interface EducatorNotificationDto {
    isNew: boolean;
    readDate?: Date | undefined;
    notificationDate: Date;
    educatorNotificationId: number;
    notificationType?: string | undefined;
    personDocumentId?: number | undefined;
    showDocumentLink?: boolean | undefined;
    showCertificationLink?: boolean | undefined;
}

export interface MarkNotificationAsReadCommand {
    educatorNotificationId: number;
}

export interface PendingApplicationDto {
    pendingServiceItems: PendingServiceItemDto[];
    toDoItems: PendingToDoItemDto[];
    errors: string[];
    isInGoodOrder: boolean;
    attestationConfirmed: boolean;
    submitted: boolean;
    paymentCompleteAtProvider: boolean;
    isLocked: boolean;
}

export interface PendingServiceItemDto {
    pendingServiceItemId: number;
    serviceCodeDescription: string;
    serviceCode: string;
    stage: PendingServiceItemStage;
    stageDescription: string;
    serviceDetailDescription: string;
    errors: string[];
    qualificationPathRequiredDocuments: QualificationPathRequiredDocumentDto[];
    isIRCertificate: boolean;
    parentPendingServiceItemId?: number | undefined;
}

export enum PendingServiceItemStage {
    Created = 0,
    QualificationPaths = 1,
    ServiceQuestions = 2,
}

export interface QualificationPathRequiredDocumentDto {
    qualificationPathRequiredDocumentId: number;
    explanation: string;
    documentCodeId: number;
    documentCodeDescription: string;
}

export interface PendingToDoItemDto extends ToDoBaseDto {
    pendingApplicationToDoItemId: number;
    status: PendingAppToDoItemStatus;
    description: string;
    additionalDetailMarkdown?: string | undefined;
    prompt: string;
}

export enum PendingAppToDoItemStatus {
    Open = 0,
    Ignored = 1,
    Applied = 2,
}

export interface SkipApplicationToDoCommand {
    pendingApplicationToDoItemId: number;
}

export interface PendingToDoItemSummaryDto {
    numberOfToDoItems: number;
    toDoItems: PendingToDoItemDto[];
}

export interface SyncAppToDoItemsCommand {
}

export interface AvailableVoucherCreditOptionDto extends SimpleSelectOptionDto {
}

export interface AvailableCertificatesDto {
    publicCertificateGroups: PublicCertificateGroupDto[];
}

export interface PublicCertificateGroupDto {
    code: string;
    description: string;
    certificates: PublicCertificateInfoDto[];
}

export interface PublicCertificateInfoDto {
    certificateTypeCodeId: number;
    certificateDescription: string;
    publicDescription: string;
    certificateLevelDescription: string;
    requiredAreaType?: RequiredAreaType | undefined;
    requiresLea: boolean;
    requiresProfessionalPrepInstitution: boolean;
    shouldBeDisabled: boolean;
}

export enum RequiredAreaType {
    PrimaryApprovedArea = 0,
    RestrictedApprovedArea = 1,
}

export interface CreatePendingAddCertificateServiceItemCommand {
    certificateTypeCodeId: number;
    primaryApprovedAreaId?: number | undefined;
    restrictedApprovedAreaCodeId?: number | undefined;
    leaCodeId?: number | undefined;
    professionalPreparationInstitutionId?: number | undefined;
}

export interface CreatePendingRenewCertificateServiceItemCommand {
    personCertificateIds: number[];
}

export interface CreatePendingCopyCertificateServiceItemCommand {
    personCertificateIds: number[];
}

export interface CreatePendingNameChangeServiceItemCommand {
    newFirstName: string;
    newMiddleName?: string | undefined;
    newLastName: string;
}

export interface ApprovedAreaCodeOptionForAddCertDto extends SimpleSelectOptionDto {
    relevantCertificateTypeCodes: CertAreaDetailDto[];
}

export interface CertAreaDetailDto {
    certificateTypeCodeId: number;
    nonPrimaryAreaOnly: boolean;
}

export interface CreatePendingAddApprovedAreaServiceItemCommand {
    approvedAreaCodeId: number;
}

export interface DeficiencyRemovalPendingServiceItemDto {
    allowableDeficiencyCodeIds: number[];
}

export interface CreateOrUpdatePendingRemoveDeficiencyServiceItemCommand {
    allowableDeficiencyCodeIds: number[];
}

export interface CreatePendingAddInstitutionalRecommendationServiceItemCommand {
    personPPIRecommendationId: number;
    personPPIRecommendedCertificateIds: number[];
    personPPIRecommendedCertificateEndorsementCodeIds: number[];
}

export interface QualificationPathQuestionDto {
    qualificationPathId: number;
    qualificationPathQuestionId: number;
    questionText: string;
    questionResponse?: boolean | undefined;
}

export interface GetQualificationPathQuestionsQuery {
    pendingServiceItemId: number;
}

export interface SubmitQualificationPathResponsesCommand {
    pendingServiceItemId: number;
    questionResponses: QualificationPathQuestionResponseItem[];
}

export interface QualificationPathQuestionResponseItem {
    qualificationPathQuestionId: number;
    response?: boolean | undefined;
}

export interface DeletePendingServiceItemDto {
    serviceCode: string;
}

export interface DeletePendingServiceItemCommand {
    pendingServiceItemId: number;
}

export interface QuestionSummaryDto {
    hasQualificationPathQuestions: boolean;
    serviceItemQuestionGroups: ServiceItemQuestionGroupDto[];
    requiredDocumentsStatus: QuestionGroupStatus;
}

export interface ServiceItemQuestionGroupDto {
    questionGroup: AppQuestionGroup;
    questionGroupDescription: string;
    status: QuestionGroupStatus;
    statusDescription: string;
}

export enum AppQuestionGroup {
    DegreeInfo = 0,
    TestInfo = 1,
    ReciprocalCertificateInfo = 2,
    PreK12TeachingExperienceInfo = 3,
    LeadershipProfessionalExperienceInfo = 4,
    CTEExperienceInfo = 5,
    CourseworkInfo = 6,
}

export enum QuestionGroupStatus {
    NotStarted = 0,
    Skipped = 1,
    Completed = 2,
}

export interface GetQuestionSummaryQuery {
    pendingServiceItemId: number;
}

export interface GetPendingAppDocumentQuery {
    pendingApplicationDocumentId: number;
}

export interface PublicEndorsementGroupDto {
    code: string;
    description: string;
    endorsementGroupEndorsements: PublicEndorsementGroupEndorsementDto[];
}

export interface PublicEndorsementGroupEndorsementDto {
    publicEndorsementGroupEndorsementCodeId: number;
    endorsementCodeId: number;
    endorsementDescription: string;
    endorsementLevelDescriptions: EndorsementLevelDescriptionDto[];
}

export interface EndorsementLevelDescriptionDto {
    endorsementCodeId: number;
    endorsementLevelCodeId: number;
    levelDescription: string;
    publicDescription: string;
    requiresLanguageCode: boolean;
}

export interface CreatePendingAddEndorsementServiceItemCommand {
    endorsementCodeId: number;
    endorsementLevelCodeId: number;
    languageCodeId?: number | undefined;
}

export interface CreatePendingExtendCertificateServiceItemCommand {
    personCertificateIds: number[];
    visaExpireDate?: Date | undefined;
}

export interface RecommendationStatusDto {
    hasUnauthorizedCohortStudentProgram: boolean;
    hasUnissuedInstitutionalRecommendations: boolean;
    unissuedCertificateDescriptions: string[];
}

export interface ManuallyWithdrawFromCohortStudentProgramCommand {
    serviceCode: string;
    certificateTypeCodeId?: number | undefined;
    endorsementCodeId?: number | undefined;
}

export interface EducatorProfessionalDevelopmentHistoryDto {
    professionalDevelopmentRecordId?: number | undefined;
    professionalDevelopmentVerificationRequestId?: number | undefined;
    completionDate?: Date | undefined;
    description?: string | undefined;
    hours?: number | undefined;
    source?: string | undefined;
    status?: string | undefined;
    personDocumentId?: number | undefined;
    supportingDocumentFileName?: string | undefined;
    details?: EducatorProfessionalDevelopmentHistoryDetailsDto | undefined;
}

export interface EducatorProfessionalDevelopmentHistoryDetailsDto {
    processedDate?: Date | undefined;
    rejectionDetails?: string | undefined;
}

export interface EmploymentInformationDto {
    isNotEmployedByAnLea: boolean;
    isEmployedByOptedInLea: boolean;
    shouldSeeVerificationRequestForm: boolean;
}

export interface RenewalProfessionalDevelopmentRequirementDto {
    hasInsufficientHours: boolean;
    requiredHours?: number | undefined;
    totalHoursOnRecord?: number | undefined;
    personCertificateId?: number | undefined;
}

export interface GetRenewalProfessionalDevelopmentRequirementQuery {
    selectedRenewalCertificateIds: number[];
}

export interface CreateProfessionalDevelopmentVerificationRequestCommand {
    description?: string | undefined;
    hours: number;
    completionDate: Date;
    leaCodeId?: number | undefined;
    supportingDocument?: string | undefined;
}

export interface EducatorProfileInfoDto {
    name?: string | undefined;
    ein?: string | undefined;
    isConfirmed: boolean;
    fingerprintCardValidityStatus?: string | undefined;
    adeConnectUserAccount?: string | undefined;
}

export interface EducatorProfileTestDto {
    personTestId: number;
    testDate: Date;
    testCode: string;
    description: string;
    status: string;
    totalScaledScore?: number | undefined;
}

export interface EducatorProfileEducationDto {
    personDegreeId: number;
    degreeLevel: string;
    degreeDescription: string;
    degreeMajor: string;
    awardDate: Date;
    institution: string;
    state: string;
    isOutOfCountry: boolean;
}

export interface PersonAddressDto {
    personAddressId: number;
    line1: string;
    line2?: string | undefined;
    city?: string | undefined;
    stateCode?: string | undefined;
    stateCodeId?: number | undefined;
    cityStateProvince?: string | undefined;
    zipCode: string;
    zipPlusFourCode?: string | undefined;
    isOutOfCountry: boolean;
    country?: string | undefined;
}

export interface PersonPhoneDto {
    personPhoneNumberId: number;
    phoneCodeId: number;
    description: string;
    phoneNumber: string;
    isMobile: boolean;
    isActive: boolean;
}

export interface PersonEmailDto {
    personEmailId: number;
    emailCodeId: number;
    description: string;
    email: string;
}

export interface AddOrUpdatePersonsAddressCommand {
    personAddressId?: number | undefined;
    line1: string;
    line2?: string | undefined;
    outOfCountry?: boolean | undefined;
    city?: string | undefined;
    stateCodeId?: number | undefined;
    cityStateProvince?: string | undefined;
    zipCode: string;
    zipPlusFourOption?: string | undefined;
    country?: string | undefined;
}

export interface AddOrUpdatePersonsPhoneCommand {
    personPhoneNumberId?: number | undefined;
    phoneCodeId?: number | undefined;
    number?: string | undefined;
    isMobile?: boolean | undefined;
}

export interface DeletePersonsPhoneCommand {
    personPhoneNumberId: number;
}

export interface AddOrUpdatePersonsEmailCommand {
    personEmailId?: number | undefined;
    emailCodeId?: number | undefined;
    email?: string | undefined;
}

export interface DeletePersonsEmailCommand {
    personEmailId: number;
}

export interface PublicSearchEducatorDto {
    educators: PublicEducatorDto[];
    maxPageNumber: number;
    fiscalYear: string;
}

export interface PublicEducatorDto {
    lastName: string;
    firstName: string;
    middleInitial?: string | undefined;
    ein: string;
    positions: PublicEducatorPositionDto[];
    personId: number;
}

export interface PublicEducatorPositionDto {
    description?: string | undefined;
    gradesTaught?: string | undefined;
}

export interface GetPublicEducatorSearchQuery {
    lastName?: string | undefined;
    firstName?: string | undefined;
    positionId?: number | undefined;
    teachingGrade?: string | undefined;
    ein?: string | undefined;
    pageNumber: number;
    pageSize: number;
    sortBy: SortField;
    sortDirection: SortDirection;
}

export enum SortField {
    FirstName = 0,
    LastName = 1,
}

export enum SortDirection {
    ASC = 0,
    DESC = 1,
}

export interface PublicEducatorCertificateDetailDto {
    name: string;
    educatorId?: string | undefined;
    positions: PublicEducatorPositionDto[];
    certificates: PublicEducatorCertificateDto[];
    approvedAreas: PublicEducatorApprovedAreaDto[];
    endorsements: PublicEducatorEndorsementDto[];
    hasDiscipline: boolean;
}

export interface PublicEducatorCertificateDto {
    personCertificateId: number;
    description: string;
    startDate: Date;
    expirationDate: Date;
    statusCode: CertificateStatusCode;
    restrictedApprovedArea?: string | undefined;
    approvedArea?: string | undefined;
    allowableDeficiencies: PersonCertificateAllowableDeficiencyDto[];
}

export interface Entity {
    createdBy?: string | undefined;
    createdDate: Date;
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    domainEvents: INotification[];
}

export interface CodeTableBase extends Entity {
    code: string;
    description: string;
    isActive: boolean;
    sortOrder: number;
}

export interface CertificateStatusCode extends CodeTableBase {
    certificateStatusCodeId: number;
    statusGroup: CertificateStatusGroup;
    canBeReinstated: boolean;
}

export enum CertificateStatusGroup {
    Actionable = 0,
    NonActionable = 1,
    Disciplined = 2,
}

/** Marker interface to represent a notification */
export interface INotification {
}

export interface PersonCertificateAllowableDeficiencyDto {
    description: string;
    startDate: Date;
    endDate: Date;
}

export interface PublicEducatorApprovedAreaDto {
    personAreaId: number;
    areaName: string;
    lapseDate?: Date | undefined;
    appliesTo: string[];
}

export interface PublicEducatorEndorsementDto {
    endorsementCodeDescription: string;
    endorsementLevelDescription: string;
    lapseDate?: Date | undefined;
    expireDate?: Date | undefined;
}

export interface NewPublicEducatorSearchQuery {
    lastName?: string | undefined;
    firstName?: string | undefined;
    positionCodeId?: number | undefined;
    gradeLevelCodeId?: number | undefined;
    ein?: string | undefined;
    pageNumber: number;
    pageSize: number;
    sortBy: SortField;
    sortDirection: SortDirection;
}

export interface PublicEducatorCredentialsResultDto {
    name: string;
    educatorId?: string | undefined;
    positions: PublicEducatorResultPositionDto[];
    certificates: PublicEducatorCertificateDto2[];
    approvedAreas: PublicEducatorApprovedAreaDto2[];
    endorsements: PublicEducatorEndorsementDto2[];
    hasDiscipline: boolean;
}

export interface PublicEducatorResultPositionDto {
    description?: string | undefined;
    gradesTaught: string[];
}

export interface PublicEducatorCertificateDto2 {
    personCertificateId: number;
    description: string;
    startDate: Date;
    expirationDate: Date;
    statusCode: string;
    restrictedApprovedArea?: string | undefined;
    approvedArea?: string | undefined;
    allowableDeficiencies: PersonCertificateAllowableDeficiencyDto2[];
}

export interface PersonCertificateAllowableDeficiencyDto2 {
    description: string;
    startDate: Date;
    endDate: Date;
}

export interface PublicEducatorApprovedAreaDto2 {
    personAreaId: number;
    areaName: string;
    lapseDate?: Date | undefined;
    appliesTo: string[];
}

export interface PublicEducatorEndorsementDto2 {
    endorsementCodeDescription: string;
    endorsementLevelDescription: string;
    lapseDate?: Date | undefined;
    expireDate?: Date | undefined;
}

export interface OnFileEducatorDegreeDto {
    personDegreeId: number;
    degreeLevel: string;
    degreeDescription: string;
    awardDate: Date;
    institution: string;
    state: string;
    isOutOfCountry: boolean;
}

export interface PendingApplicationDegreeDto {
    key: string;
    country?: string | undefined;
    state?: string | undefined;
    institution?: string | undefined;
    degree?: string | undefined;
    degreeType?: string | undefined;
    awardDate?: string | undefined;
    transcriptSentDate?: string | undefined;
    nameOnDegree?: string | undefined;
}

export interface AddPendingApplicationDegreeCommand {
    country?: string | undefined;
    state?: string | undefined;
    institution?: string | undefined;
    degree?: string | undefined;
    degreeType?: string | undefined;
    awardDate?: string | undefined;
    transcriptSentDate?: string | undefined;
    nameOnDegree?: string | undefined;
}

export interface DeletePendingApplicationDegreeCommand {
    degreeDataItemKey: string;
}

export interface CompleteDegreeInfoQuestionGroupCommand {
    pendingServiceItemId: number;
}

export interface OnFileEducatorTestDto {
    state: string;
    codeAndName: string;
    date: Date;
    status: string;
}

export interface PendingApplicationTestDto {
    key: string;
    state?: string | undefined;
    examNameAndCode?: string | undefined;
    passedDate?: string | undefined;
    dateSubmittedToADE?: string | undefined;
    pendingApplicationDocumentId?: number | undefined;
    documentFileName?: string | undefined;
}

export interface AddPendingApplicationTestCommand {
    state?: string | undefined;
    examNameAndCode?: string | undefined;
    passedDate?: string | undefined;
    dateSubmittedToADE?: string | undefined;
    documentContent?: string | undefined;
    fileName?: string | undefined;
}

export interface DeletePendingApplicationTestCommand {
    testDataItemKey: string;
}

export interface CompleteTestInfoQuestionGroupCommand {
    pendingServiceItemId: number;
}

export interface PendingApplicationReciprocityCertificateDto {
    key: string;
    state?: string | undefined;
    certificateLicenseDescription?: string | undefined;
    areasAndEndorsements?: string | undefined;
    effectiveDate?: string | undefined;
    expireDate?: string | undefined;
    pendingApplicationDocumentId?: number | undefined;
    documentFileName?: string | undefined;
}

export interface AddPendingApplicationReciprocityCertificateCommand {
    state?: string | undefined;
    certificateLicenseDescription?: string | undefined;
    areasAndEndorsements?: string | undefined;
    effectiveDate?: string | undefined;
    expireDate?: string | undefined;
    documentContent?: string | undefined;
    fileName?: string | undefined;
}

export interface DeletePendingApplicationReciprocityCertificateCommand {
    certificateDataItemKey: string;
}

export interface CompleteReciprocityCertificateInfoQuestionGroupCommand {
    pendingServiceItemId: number;
}

export interface PendingApplicationPreKTeachingExperienceDto {
    key: string;
    nameOfDistrictOrSchool?: string | undefined;
    locationOfDistrictOrSchool?: string | undefined;
    gradeLevel?: string | undefined;
    positionTitle?: string | undefined;
    subjectContentAreaTaught?: string | undefined;
    employmentClassification?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    verificationRequestedDate?: string | undefined;
}

export interface AddPendingApplicationPreKTeachingExperienceCommand {
    nameOfDistrictOrSchool?: string | undefined;
    locationOfDistrictOrSchool?: string | undefined;
    gradeLevel?: string | undefined;
    positionTitle?: string | undefined;
    subjectContentAreaTaught?: string | undefined;
    employmentClassification?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    verificationRequestedDate?: string | undefined;
}

export interface DeletePendingApplicationPreKTeachingExperienceCommand {
    preKTeachingExperienceDataItemKey: string;
}

export interface CompletePreKTeachingExperienceInfoQuestionGroupCommand {
    pendingServiceItemId: number;
}

export interface PendingApplicationCteExperienceDto {
    key: string;
    nameOfEmployer?: string | undefined;
    businessCityState?: string | undefined;
    positionTitle?: string | undefined;
    jobDutiesDescription?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    verificationRequestedDate?: string | undefined;
}

export interface AddPendingApplicationCteExperienceCommand {
    nameOfEmployer?: string | undefined;
    businessCityState?: string | undefined;
    positionTitle?: string | undefined;
    jobDutiesDescription?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    verificationRequestedDate?: string | undefined;
}

export interface DeletePendingApplicationCteExperienceCommand {
    cteExperienceDataItemKey: string;
}

export interface CompleteCteExperienceInfoQuestionGroupCommand {
    pendingServiceItemId: number;
}

export interface PendingApplicationCourseworkDto {
    key: string;
    descriptionOfCoursesCompleted?: string | undefined;
    creditHours?: string | undefined;
    institutionState?: string | undefined;
    institutionName?: string | undefined;
    nameOnTranscript?: string | undefined;
    transcriptSentDate?: string | undefined;
    pendingApplicationDocumentId?: number | undefined;
    documentFileName?: string | undefined;
}

export interface AddPendingApplicationCourseworkCommand {
    descriptionOfCoursesCompleted?: string | undefined;
    institutionState?: string | undefined;
    institutionName?: string | undefined;
    nameOnTranscript?: string | undefined;
    transcriptSentDate?: string | undefined;
}

export interface DeletePendingApplicationCourseworkCommand {
    courseworkDataItemKey: string;
}

export interface CompleteCourseworkInfoQuestionGroupCommand {
    pendingServiceItemId: number;
}

export interface PendingApplicationLeadershipDto {
    key: string;
    nameOfDistrictOrSchool?: string | undefined;
    locationOfDistrictOrSchool?: string | undefined;
    nameOfEmployer?: string | undefined;
    employmentClassification?: string | undefined;
    positionTitle?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    verificationRequestedDate?: string | undefined;
}

export interface AddPendingApplicationLeadershipCommand {
    nameOfDistrictOrSchool?: string | undefined;
    locationOfDistrictOrSchool?: string | undefined;
    nameOfEmployer?: string | undefined;
    employmentClassification?: string | undefined;
    positionTitle?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    verificationRequestedDate?: string | undefined;
}

export interface DeletePendingApplicationLeadershipCommand {
    leadershipDataItemKey: string;
}

export interface CompleteLeadershipInfoQuestionGroupCommand {
    pendingServiceItemId: number;
}

export interface AddRequiredDocumentsCommand {
    pendingServiceItemId: number;
    documents: RequiredDocumentUploadDto[];
}

export interface RequiredDocumentUploadDto {
    qualificationPathRequiredDocumentId: number;
    fileName: string;
    content: string;
    documentCodeId: number;
}

export interface PendingApplicationRequiredDocumentDto {
    qualificationPathRequiredDocumentId: number;
    pendingApplicationDocumentId: number;
    fileName: string;
    content: string;
    documentCodeId: number;
}

export interface GetPendingApplicationRequiredDocumentsQuery {
    pendingServiceItemId: number;
}

export interface Payload {

    [key: string]: any;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}